import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../Controllers/hooks";
import { RootState } from "../../../../Controllers/Store";
import { useSelector } from "react-redux";
import { hasPermission } from "../../../../Controllers/Selectors/permissionsSelector";
import { startOfMonth, endOfMonth } from "date-fns";

import "../Css/Attendance.css";
import "../Css/Attendance-responsive.css";

import { Ripple } from "primereact/ripple";
import { Dropdown, DropdownChangeEvent, DropdownProps } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Nullable } from "primereact/ts-helpers";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { confirmDialog } from "primereact/confirmdialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { InputNumberChangeEvent } from "primereact/inputnumber";
import { AnimatePresence, motion } from "framer-motion";

import NoDataCreated from "../../../../Components/NoDataCreated";
import ErrorPage from "../../../../Components/ErrorPage";
import PageLoader from "../../../../Components/PageLoader";
import GoBackButton from "../../../../Components/GoBackButton";
import DatePicker from "../../../../Components/DatePicker";
import NumberInput from "../../../../Components/NumberInput";
import TableActionButton from "../../../../Components/TableActionButton";
import ViewDataGroup from "../../../../Components/DataViewModal/ViewDataGroup";
import CustomTableLoader from "../../../../Components/CustomTableLoader";
import { checkModelSelected, checkNumber, checkText } from "../../../../Utils/Validator";
import { goToTop } from "../../../../Components/goToTop";
import { baseURL } from "../../../../Api/ApiConstant";
import { formatDate, formatYearMonth, parseStringToDate } from "../../../../Utils/getDate";
import { amountDisplay, getAppCurrencyType } from "../../../../Utils/Common";

import { fetchAllProjects } from "../../../../Controllers/Thunks/projectThunks";
import { AttendanceProjectType } from "../../../../Controllers/Types/HeyTraderTypes/Attendances/AttendanceProjectType";
import { fetchAttendanceViewDetail, getAttendanceEmployeeListNew, getAttendanceExpenseList, getAttendanceHomeNew, getAttendanceProjectNew } from "../../../../Controllers/Thunks/NewAttendanceThunks";
import { Project } from "../../../../Controllers/Types/Project/ProjectInterface";
import { AttendanceDayView } from "../../../../Controllers/Types/HeyTraderTypes/Attendances/New/AttendanceDayView";
import { AttendanceSiteView } from "../../../../Controllers/Types/HeyTraderTypes/Attendances/New/AttendanceSiteView";
import { AttendanceStaffView, StaffPaidData } from "../../../../Controllers/Types/HeyTraderTypes/Attendances/New/AttendanceStaffView";
import { AttendanceData } from "../../../../Controllers/Types/HeyTraderTypes/Attendances/New/AttendanceData";
import { SiteEmployeeType } from "../../../../Controllers/Types/HeyTraderTypes/Attendances/SiteEmployeeType";
import { Expense } from "../../../../Controllers/Types/HeyTraderTypes/Attendances/New/Expense";
import { AttendanceHomeSearch } from "../../../../Controllers/Types/HeyTraderTypes/Attendances/New/AttendanceHomeSearch";
import { activeAttendancesEmployeeNew, addAttendancesNew, addAttendanceStaffPaymentNew, deleteAttendanceDataNew, deleteAttendanceStaffPaymentNew, updateAttendancesNew, updateAttendanceStaffPaymentNew } from "../../../../Api/NewAttendance/NewAttendanceService";
import { ShareContactTypes } from "../../../../Controllers/Types/HeyTraderTypes/ShareContactTypes";

import { ShareContactType, mapShareContactType } from "../../../../Controllers/Types/Share/ShareContactType";

import { shareAttendanceNewAPI } from "../../../../Api/HeyTraderService/AttendanceServices";
import ShareModal from "../../../../Components/ShareModal";
import { getLoginUserRoleName, UserRoleName } from "../../../../Utils/LoginUserRoleName";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { getAttendanceEmployeeList } from "../../../../Controllers/Thunks/HeyTraderThunks";
import { AttendanceNavigateData } from "../../../../Controllers/Types/HeyTraderTypes/Attendances/New/Common";
import { AttendanceEmployeeType } from "../../../../Controllers/Types/HeyTraderTypes/Attendances/AttendanceEmployeeType";
import { Image } from "primereact/image";
import { Checkbox } from "primereact/checkbox";
import DataException from "../../../../Components/DataException";
import { format } from "date-fns";
import { AttendanceViewDetailInput } from "../../../../Controllers/Types/HeyTraderTypes/Attendances/New/AttendanceViewDetail";

const Attendance: React.FC = () => {
    const today = new Date();
    const currentMonthStart = startOfMonth(today);
    const currentMonthEnd = endOfMonth(today);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const toast = useRef<Toast>(null);
    const currencySymbol = getAppCurrencyType();

    const [loading, setLoading] = useState<boolean>(false);
    const [initialDataLoading, setInitialDataLoading] = useState<boolean>(true);
    const [dataState, setDataState] = useState<"Add" | "Edit">("Add");

    const attendanceViewOptions = ['Day', 'Site', 'Staff'] as const;
    const [attendanceView, setAttendanceView] = useState<'Day' | 'Site' | 'Staff'>('Day');
    const [rootProject, setRootProject] = useState<AttendanceProjectType | null>(null);

    const [dateFilter, setDateFilter] = useState<Nullable<Date>>(today);
    const [daySiteFilter, setDaySiteFilter] = useState<AttendanceProjectType | null>(null);
    const [siteOptionsData, setSiteOptionsData] = useState<AttendanceProjectType[]>([]);
    const [showAttendanceModal, setShowAttendanceModal] = useState<boolean>(false);
    const [showAttendanceViewModal, setShowAttendanceViewModal] = useState<boolean>(false);

    const [sitesData, setSitesData] = useState<AttendanceProjectType[]>([]);
    const [siteEmployeesData, setSiteEmployeesData] = useState<SiteEmployeeType[]>([]);
    const [attendanceDayData, setAttendanceDayData] = useState<AttendanceDayView[]>([]);
    const [attendanceSiteData, setAttendanceSiteData] = useState<AttendanceSiteView[]>([]);
    const [attendanceStaffData, setAttendanceStaffData] = useState<AttendanceStaffView[]>([]);
    const [attendanceDeleteLoadingId, setAttendanceDeleteLoadingId] = useState<number | null>(null);
    const [selectedAttendanceData, setSelectedAttendanceData] = useState<AttendanceData | null>(null);
    const [selectedDayAttendanceData, setSelectedDayAttendanceData] = useState<AttendanceDayView | null>(null);
    const [attendanceUpdateHasChanges, setAttendanceUpdateHasChanges] = useState<boolean>(false);
    const [viewDate, setViewDate] = useState<Date>(new Date());
    const [highlightedDates, setHighlightedDates] = useState<Record<string, string>>({});

    const [showStaffViewDetailModal, setShowStaffViewDetailModal] = useState<boolean>(false);
    const [staffDetailViewState, setStaffDetailViewState] = useState<'Attendance' | 'Payment'>('Attendance');
    const [staffViewDetailMonthFilter, setstaffViewDetailMonthFilter] = useState<Nullable<Date>>(today);

    // Staff view detail state data
    const {
        loadingViewDetail, errorViewDetail, viewDetail
    } = useAppSelector((state) => state?.newAttendanceViewDetail);

    // Attendance fields
    const [selectedAttendanceProject, setSelectedAttendanceProject] = useState<AttendanceProjectType | null>(null);
    const [selectedSiteEmployees, setSelectedSiteEmployees] = useState<SiteEmployeeType[]>([]);
    const [workingHours, setWorkingHours] = useState<number | null>(8);
    const [workingDays, setWorkingDays] = useState<number | null>(1);

    // Errors
    const [attendanceProjectError, setAttendanceProjectError] = useState<string>('');
    const [siteEmployeesError, setSiteEmployeesError] = useState<string>('');
    const [workingHoursError, setWorkingHoursError] = useState<string>('');
    const [workingDaysError, setWorkingDaysError] = useState<string>('');
    const [attendanceDateError, setAttendanceDateError] = useState<string>('');

    // Site view filters
    const [siteEmployeeFilterOptionsData, setSiteEmployeeFilterOptionsData] = useState<SiteEmployeeType[]>([]);
    const [siteFilter, setSiteFilter] = useState<AttendanceProjectType | null>(null);
    const [siteEmployeeFilter, setSiteEmployeeFilter] = useState<SiteEmployeeType | null>(null);
    const [startDateFilter, setStartDateFilter] = useState<Nullable<Date>>(today);
    const [endDateFilter, setEndDateFilter] = useState<Nullable<Date>>(today);

    // Staff view filters
    const [staffFilterOptionsData, setStaffFilterOptionsData] = useState<SiteEmployeeType[]>([]);
    const [staffSiteOptionsData, setStaffSiteOptionsData] = useState<AttendanceProjectType[]>([]);
    const [staffFilter, setStaffFilter] = useState<SiteEmployeeType | null>(null);
    const [staffSiteFilter, setStaffSiteFilter] = useState<AttendanceProjectType | null>(null);
    const [staffStartDateFilter, setStaffStartDateFilter] = useState<Nullable<Date>>(currentMonthStart);
    const [staffEndDateFilter, setStaffEndDateFilter] = useState<Nullable<Date>>(today);

    // Staff payment fields
    const [selectedStaffPaidData, setSelectedStaffPaidData] = useState<StaffPaidData | null>(null);
    const [expandedExpenseIds, setExpandedExpenseIds] = useState<number[]>([]);
    const [expandedPaidData, setExpandedPaidData] = useState<boolean>(true);
    const [staffPaymentUpdateHasChanges, setStaffPaymentUpdateHasChanges] = useState<boolean>(false);
    const [staffPaymentDeleteLoadingId, setStaffPaymentDeleteLoadingId] = useState<number | null>(null);
    const [showStaffPaymentModal, setShowStaffPaymentModal] = useState<boolean>(false);
    const [staffPaymentDate, setStaffPaymentDate] = useState<Nullable<Date>>(today);
    const [paymentExpense, setPaymentExpense] = useState<Expense | null>(null);
    const [staffPaymentAmount, setStaffPaymentAmount] = useState<number | null>(null);

    // Errors
    const [paymentStaffError, setPaymentStaffError] = useState<string>('');
    const [staffPaymentDateError, setStaffPaymentDateError] = useState<string>('');
    const [paymentExpenseError, setPaymentExpenseError] = useState<string>('');
    const [staffPaymentAmountError, setStaffPaymentAmountError] = useState<string>('');

    // Attendance data
    const dataLoading = useAppSelector((state) => state?.newAttendanceHome?.loader);
    const dataError = useAppSelector((state) => state?.newAttendanceHome?.errorDisplay);
    const attendance = useAppSelector((state) => state?.newAttendanceHome?.attendanceHome);

    // Expense data
    const expenseLoading = useAppSelector((state) => state?.newAttendanceExpense?.loader);
    const expenseError = useAppSelector((state) => state?.newAttendanceExpense?.errorDisplay);
    const expenses = useAppSelector((state) => state?.newAttendanceExpense?.attendanceExpenseList);

    // Projects data
    const projectLoading = useAppSelector((state) => state?.newAttendanceProject?.loader);
    const projectError = useAppSelector((state) => state?.newAttendanceProject?.errorDisplay);
    const projects = useAppSelector((state) => state?.newAttendanceProject?.attendanceProjectList);

    // Site employees data
    const siteEmployeeLoading = useAppSelector((state) => state?.newAttendanceEmployee?.loader);
    const siteEmployeeError = useAppSelector((state) => state?.newAttendanceEmployee?.errorDisplay);
    const siteEmployeesDB = useAppSelector((state) => state.newAttendanceEmployee.attendanceEmployeeList);
    const [siteEmployees, setSiteEmployees] = useState<SiteEmployeeType[]>([]);
    const [loginUserRoleName, setLoginUserRoleName] = useState<UserRoleName | ''>('');

    const rootNavigateData = location.state.navigateData as AttendanceNavigateData | undefined | null;

    useEffect(() => {
        if (!rootNavigateData) return;

        const timer = setTimeout(() => {
            setDateFilter(rootNavigateData?.selectedDate ?? null);
            setSelectedAttendanceProject(rootNavigateData?.selectedProject ?? null);
            setDaySiteFilter(rootNavigateData?.selectedProject ?? null);
            setSelectedSiteEmployees(rootNavigateData?.selectedEmployees ?? []);

            setShowEmployeeSelectModal(!!rootNavigateData?.openStatus);
        }, 300);

        return () => clearTimeout(timer);
    }, [rootNavigateData]);


    useEffect(() => {
        const fetchUserRole = async () => {
            const roleName = await getLoginUserRoleName();
            setLoginUserRoleName(roleName);
        };

        fetchUserRole();
    }, []);


    // share features 
    const [showContactShareModal, setShowContactShareModal] = useState<boolean>(false);
    const [sharedList, setSharedList] = useState<ShareContactType[]>([]);
    const [projectContactIds, setProjectContactIds] = useState<number[]>([]);
    const [attendanceContactData, setAttendanceContactData] = useState<ShareContactTypes[]>([]);
    const canAddAttendance = (loginUserRoleName === "commercial client" || loginUserRoleName === "domestic client") ? false : true;

    /* **************************************************************** Premission */
    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) =>
            hasPermission(state, screen, permission)
        );
    };

    const hasPermissionAddAttendance = (useCanEdit("Attendance", "add_attendance") && canAddAttendance);
    const hasPermissionEditAttendance = (useCanEdit("Attendance", "edit_attendance") && canAddAttendance);
    const hasPermissionDeleteAttendance = (useCanEdit("Attendance", "delete_attendance") && canAddAttendance);
    const hasPermissionAddEmployee = (useCanEdit("Attendance", "add_employee") && canAddAttendance);
    const hasPermissionAddStaffPayment = (useCanEdit("Attendance", "add_staff_payment") && canAddAttendance);
    const hasPermissionEditStaffPayment = (useCanEdit("Attendance", "edit_staff_payment") && canAddAttendance);
    const hasPermissionDeleteStaffPayment = (useCanEdit("Attendance", "delete_staff_payment") && canAddAttendance);
    /* **************************************************************** */


    useEffect(() => {
        const savedAttendanceView = localStorage.getItem("activeAttendanceView") as 'Day' | 'Site' | 'Staff';

        if (savedAttendanceView) {
            setAttendanceView(savedAttendanceView)
        } else {
            setAttendanceView('Day');
        }
    }, []);

    useEffect(() => {
        dispatch(fetchAllProjects());
        dispatch(getAttendanceProjectNew());
        dispatch(getAttendanceExpenseList());
    }, [dispatch]);

    // this logic for set employee details client only view and users can add
    useEffect(() => {
        if (loginUserRoleName === "commercial client" || loginUserRoleName === "domestic client") {
            if (siteFilter && siteFilter?.work_employee_list?.length! > 0) {
                setSiteEmployees(siteFilter?.work_employee_list!);
            }

        } else {
            if (siteEmployeesDB && siteEmployeesDB?.length > 0) {
                setSiteEmployees(siteEmployeesDB);
            }
        }
    }, [siteEmployeesDB, siteFilter, loginUserRoleName]);

    // altration all project eployees need to pick
    useEffect(() => {
        if (loginUserRoleName === "commercial client" || loginUserRoleName === "domestic client") {
            if (!sitesData || sitesData.length === 0) {
                setSiteEmployees([]);
                return;
            }

            // collect all employees from all sites
            const allEmployees = sitesData.flatMap(
                (site) => site?.work_employee_list || []
            );

            // remove duplicates using employee id
            const uniqueEmployees = Array.from(
                new Map(
                    allEmployees.map((emp) => [emp.personalInfo?.id, emp]) // emp.id = unique key
                ).values()
            );

            setSiteEmployees(uniqueEmployees);

        } else {
            if (siteEmployeesDB && siteEmployeesDB?.length > 0) {
                setSiteEmployees(siteEmployeesDB);
            }
        }
    }, [sitesData, loginUserRoleName, siteEmployeesDB]);

    // new
    //   useEffect(() => {
    //     if(siteFilter && siteFilter?.work_employee_list?.length! >0){

    //         setSiteEmployees(siteFilter?.work_employee_list!);
    //     }
    // }, [siteFilter]);

    useEffect(() => {
        handleAttendanceEmployeeDataGet();
    }, [attendanceView, dateFilter, dispatch]);

    const handleAttendanceEmployeeDataGet = async () => {
        if (attendanceView === 'Day') {
            dispatch(getAttendanceEmployeeListNew(formatDate(dateFilter ?? null)));
        } else {
            dispatch(getAttendanceEmployeeListNew());
        }
    }

    useEffect(() => {
        if (projects && projects?.length > 0) {
            const allSitesOption: AttendanceProjectType = {
                project_id: null,
                job_number: '',
                address: 'All Sites',
                full_address: 'All Sites'
            }

            const staffSiteOptions: AttendanceProjectType[] = [
                allSitesOption,
                ...projects
            ]

            setSitesData(projects);
            setSiteOptionsData(projects);
            setStaffSiteOptionsData(staffSiteOptions);

            if (siteFilter && siteFilter?.project_id) {
                // re update from projects
                const project = projects.find((e) => e.project_id === siteFilter?.project_id);
                setSiteFilter(project ?? null);
                setDaySiteFilter(project ?? null);
            } else {
                // inital setup
                if (location.state && location.state.mainProject) {
                    const stateProject = location.state.mainProject as Project;

                    const project = projects.find((e) => e.project_id === stateProject?.project_id);
                    setSiteFilter(project ?? null);
                    setStaffSiteFilter(project ?? null)
                    setDaySiteFilter(project ?? null);
                } else {
                    setSiteFilter(projects[0] ?? null);
                    setDaySiteFilter(projects[0] ?? null);
                    setStaffSiteFilter(staffSiteOptions[0] ?? null);
                }
            }
        } else {
            setSitesData([]);
            setSiteOptionsData([]);
            setStaffSiteOptionsData([]);
        }
    }, [projects, siteFilter, location.state]);

    useEffect(() => {
        if (Array.isArray(siteEmployees) && siteEmployees.length > 0) {
            setStaffFilterOptionsData(siteEmployees);
            setStaffFilter(siteEmployees[0] ?? null);

            const activeSiteEmployees = siteEmployees.filter(
                (employee) => employee?.attenanceEmployee?.status === 1
            );

            setSiteEmployeesData(activeSiteEmployees);

            const allEmployeesOption: SiteEmployeeType = {
                personalInfo: {
                    first_name: "All",
                    last_name: "Employees"
                }
            };

            setSiteEmployeeFilterOptionsData([
                allEmployeesOption,
                ...siteEmployees
            ]);

            setSiteEmployeeFilter(allEmployeesOption);
        } else {
            setStaffFilterOptionsData([]);
            setStaffFilter(null);
            setSiteEmployeesData([]);
            const allEmployeesOption: SiteEmployeeType = {
                personalInfo: {
                    first_name: "All",
                    last_name: "Employees"
                }
            };

            setSiteEmployeeFilterOptionsData([allEmployeesOption]);
            setSiteEmployeeFilter(allEmployeesOption);
        }
    }, [siteEmployees]);

    useEffect(() => {
        const stateProject = location?.state?.mainProject as Project | undefined;
        const navigateProject = rootNavigateData?.selectedProject ?? null;

        if (stateProject) {
            const match = sitesData.find(
                (e) => e.project_id === stateProject.project_id
            );

            if (match) {
                setRootProject(match);
                // setDaySiteFilter(match);
                // setSiteFilter(match);
                setSelectedAttendanceProject(match);

            } else {
                setRootProject(null);
                setSelectedAttendanceProject(null);
                // setDaySiteFilter(null);
                // setSiteFilter(projects[0] ?? null);
            }
        } else if (navigateProject) {
            setSelectedAttendanceProject(navigateProject);
            setDaySiteFilter(navigateProject);
        } else {
            setRootProject(null);
            setSelectedAttendanceProject(null);
            // setDaySiteFilter(null);
            // setSiteFilter(projects[0] ?? null);
        }
    }, [location?.state.mainProject, sitesData, projects, rootNavigateData]);

    useEffect(() => {
        setAttendanceContactData(siteFilter?.contact!);
    }, [siteFilter]);

    // refill shared list data
    useEffect(() => {
        if (!siteFilter) return;

        const shareList = siteFilter?.share_list ?? [];
        if (shareList.length > 0) {
            const results: ShareContactType[] = shareList.map((e) => {
                const dt: Partial<ShareContactType> = {
                    id: e.id,
                    first_name: e.first_name,
                    last_name: e.last_name!,
                    profile_image: e.profile_image,
                    email: e.email!,
                    type: e.main_type!,
                    by: e.by,
                    can_edit: e.can_edit,
                    can_view: 1, // forcing as "viewable"
                };

                return mapShareContactType(dt);
            });

            setSharedList(results);
        } else {
            setSharedList([]); // clear if no share list
        }
    }, [siteFilter]);

    useEffect(() => {
        if (attendanceContactData && attendanceContactData.length > 0) {
            const ids = attendanceContactData.map((e) => e.id)
            setProjectContactIds(ids);
        }
    }, [attendanceContactData])

    useEffect(() => {
        const fetchData = async () => {
            await handleAttendanceDataGet();
        }

        fetchData();
    }, [
        attendanceView,
        dateFilter,
        siteFilter,
        siteEmployeeFilter,
        startDateFilter,
        endDateFilter,
        staffFilter,
        staffSiteFilter,
        staffStartDateFilter,
        staffEndDateFilter,
    ]);

    const handleAttendanceDataGet = async () => {
        const viewType = attendanceView;

        // Day view filter
        const date = formatDate(dateFilter ?? null) ?? null;

        // Site view filters
        const projectId = siteFilter?.project_id ?? null;
        const employeeId = siteEmployeeFilter?.attenanceEmployee?.personal_info_id ?? null;
        const startDate = formatDate(startDateFilter ?? null) ?? null;
        const endDate = formatDate(endDateFilter ?? null) ?? null;

        // Staff view filters
        const staffId = staffFilter?.attenanceEmployee?.personal_info_id ?? null;
        const staffProjectId = staffSiteFilter?.project_id ?? null;
        const staffStartDate = formatDate(staffStartDateFilter ?? null) ?? null;
        const staffEndDate = formatDate(staffEndDateFilter ?? null) ?? null;

        let requestData: AttendanceHomeSearch = {
            view_type: viewType,

            date:
                viewType === 'Day'
                    ? date
                    : viewType === 'Site'
                        ? startDate
                        : viewType === 'Staff'
                            ? staffStartDate
                            : null,

            end_date:
                viewType === 'Site'
                    ? endDate
                    : viewType === 'Staff'
                        ? staffEndDate
                        : null,

            project_id:
                viewType === 'Site'
                    ? projectId
                    : viewType === 'Staff'
                        ? staffProjectId
                        : null,

            personal_info_id:
                viewType === 'Site'
                    ? employeeId
                    : viewType === 'Staff'
                        ? staffId
                        : null,

            year: null
        }

        try {
            if (attendanceView !== "Staff") {
                await dispatch(getAttendanceHomeNew(requestData));
            } else if (attendanceView === "Staff" && staffId !== null) {
                await dispatch(getAttendanceHomeNew(requestData));
            }

        } finally {
            setInitialDataLoading(false);
        }
    }

    useEffect(() => {
        if (attendance) {
            // Day data
            let filteredDayData = [...attendance.day_view ?? []];

            if (daySiteFilter) {
                filteredDayData = filteredDayData?.filter(data => data?.project_id === daySiteFilter?.project_id);
            }

            setAttendanceDayData(filteredDayData);

            // Site data
            setAttendanceSiteData(attendance.site_view ?? []);

            // Staff data
            setAttendanceStaffData(attendance.staff_view ?? []);
        } else {
            setAttendanceDayData([]);
            setAttendanceSiteData([]);
            setAttendanceStaffData([]);
        }
    }, [attendance, daySiteFilter]);

    useEffect(() => {
        if (!expenses || expenses?.length === 0) {
            setPaymentExpense(null);
            return;
        }

        setPaymentExpense(expenses[0] ?? null);
    }, [expenses])

    const handleSwitchAttendanceView = (view: 'Day' | 'Site' | 'Staff') => {
        setAttendanceView(view);
        localStorage.setItem("activeAttendanceView", view);
    }

    /* **************************************************************** Attandance day view */
    const handleResetAttendanceFields = () => {
        setWorkingHours(8);
        setWorkingDays(1);

        if (rootProject === null) {
            setSelectedAttendanceProject(null);
        } else {
            setSelectedAttendanceProject(rootProject ?? null);
        }

        setSelectedSiteEmployees([]);

        setSelectedAttendanceData(null);
        setSelectedDayAttendanceData(null);

        setWorkingHoursError('');
        setWorkingDaysError('');
        setAttendanceProjectError('');
        setSiteEmployeesError('');
        setAttendanceDateError('');
    }

    const handleCloseAttendanceModal = () => {
        setShowAttendanceModal(false);
        handleResetAttendanceFields();
    }

    // Clear errors
    useEffect(() => {
        checkText(formatDate(dateFilter ?? null), false, setAttendanceDateError);
    }, [dateFilter]);

    useEffect(() => {
        checkModelSelected(selectedAttendanceProject !== null, false, setAttendanceProjectError);
    }, [selectedAttendanceProject]);

    useEffect(() => {
        checkModelSelected(selectedSiteEmployees?.length > 0, false, setSiteEmployeesError);
    }, [selectedSiteEmployees]);

    useEffect(() => {
        checkNumber(workingHours!, false, setWorkingHoursError);
    }, [workingHours]);

    useEffect(() => {
        checkNumber(workingDays!, false, setWorkingDaysError);
    }, [workingDays]);

    // Check Validation
    function checkCredentialsForAttandance(): boolean {
        const isValidAttandanceDate = checkText(formatDate(dateFilter ?? null), true, setAttendanceDateError);
        const isValidAttandanceProject = checkModelSelected(selectedAttendanceProject !== null, true, setAttendanceProjectError);

        if (dataState === 'Add') {
            const isValidSiteEmployees = checkModelSelected(
                Array.isArray(selectedSiteEmployees) && selectedSiteEmployees.length > 0,
                true,
                setSiteEmployeesError
            );

            return isValidAttandanceDate && isValidAttandanceProject && isValidSiteEmployees;
        }

        if (!selectedAttendanceData) {
            setWorkingHoursError('');
            setWorkingDaysError('');
            return false;
        }

        const { work_days = 0, work_hours = 0 } = selectedAttendanceData;

        const isDayType = work_hours === 0 && work_days > 0;
        const isHourType = work_days === 0 && work_hours > 0;

        const isValidWorkingHours = checkNumber(
            workingHours!,
            isHourType ? true : false,
            setWorkingHoursError
        );

        const isValidWorkingDays = checkNumber(
            workingDays!,
            isDayType ? true : false,
            setWorkingDaysError
        );

        return (
            isValidAttandanceDate &&
            isValidAttandanceProject &&
            isValidWorkingHours &&
            isValidWorkingDays
        );
    }

    // API validation
    function showAPIErrorForAttandance(keyName: string, error: string): void {
        if (keyName === "attendance_date") {
            setAttendanceDateError(error);
        }

        if (keyName === "project_id") {
            setAttendanceProjectError(error);
        }

        if (keyName === "work_hours") {
            setWorkingHoursError(error);
        }

        if (keyName === "work_days") {
            setWorkingDaysError(error);
        }

        if (keyName === "list[]") {
            setSiteEmployeesError(error);
        }
    }

    // Add attandance
    const handleAddAttendance = () => {
        setDataState('Add');
        setShowAttendanceModal(true);
        setSelectedAttendanceProject(daySiteFilter ?? null);
    }

    // Create attendance API
    const handleCreateAttendance = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!checkCredentialsForAttandance()) return;
        setLoading(true);

        try {
            const attendance_date = formatDate(dateFilter ?? null) ?? null;
            const project_id = selectedAttendanceProject?.project_id ?? null;
            const list: number[] =
                selectedSiteEmployees
                    ?.map(emp => emp.attenanceEmployee?.personal_info_id)
                    ?.filter((id): id is number => typeof id === "number")
                ?? [];

            const data = await addAttendancesNew(
                attendance_date,
                project_id,
                list,
            );

            if (data.statusCode === 200) {
                handleAttendanceDataGet();
                handleAttendanceEmployeeDataGet();

                setDaySiteFilter(selectedAttendanceProject);

                handleCloseAttendanceModal();

                toast?.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `Attendance added successfully.`,
                    life: 3000,
                });
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value]) => (
                    showAPIErrorForAttandance(key, value[0])
                ));
            } else {
                toast?.current?.show({
                    severity: "error",
                    summary: "Failed",
                    detail: "There was an error adding the attendance.",
                    life: 3000,
                });
            }
        } catch (error) {
            console.error("Error adding the attendance:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while adding the attendance.",
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    }

    // Edit attendance
    const handleEditAttendance = (attendance: AttendanceData | null, dayAttendance: AttendanceDayView | null) => {
        if (!attendance || !dayAttendance) return;

        const { work_days = 0, work_hours = 0 } = attendance;

        const isDayType = work_hours === 0 && work_days > 0;
        const isHourType = work_days === 0 && work_hours > 0;

        setDataState("Edit");
        setShowAttendanceModal(true);

        setSelectedAttendanceData(attendance);
        setSelectedDayAttendanceData(dayAttendance);

        const existingProject = sitesData?.find(
            (project) => project?.project_id === dayAttendance.project_id
        ) ?? null;

        setWorkingDays(isDayType ? (attendance.work_days ?? null) : null);
        setWorkingHours(isHourType ? (attendance.work_hours ?? null) : null);
        setSelectedAttendanceProject(existingProject);
    };

    // Check update has changes
    useEffect(() => {
        if (!selectedDayAttendanceData || !selectedAttendanceData) {
            setAttendanceUpdateHasChanges(false);
            return;
        }

        const { work_days = 0, work_hours = 0 } = selectedAttendanceData;

        const isDayType = work_hours === 0 && work_days > 0;
        const isHourType = work_days === 0 && work_hours > 0;

        let hasChanges = false;

        const projectChanged =
            selectedAttendanceProject?.project_id !== selectedDayAttendanceData?.project_id;

        const durationChanged =
            (isHourType && workingHours !== selectedAttendanceData?.work_hours) ||
            (isDayType && workingDays !== selectedAttendanceData?.work_days);

        hasChanges = projectChanged || durationChanged;

        setAttendanceUpdateHasChanges(hasChanges);
    }, [
        selectedDayAttendanceData,
        selectedAttendanceData,
        selectedAttendanceProject,
        workingHours,
        workingDays
    ]);

    // Update attendance API
    const handleUpdateAttendance = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForAttandance() || selectedAttendanceData === null) return;

        setLoading(true);

        try {
            const attendance_date = formatDate(dateFilter ?? null) ?? null;
            const personal_info_id = selectedAttendanceData?.personal_info_id ?? null;
            const project_id = selectedAttendanceProject?.project_id ?? null;
            const work_hours = workingHours ?? null;
            const work_days = workingDays ?? null;

            const data = await updateAttendancesNew(
                attendance_date,
                personal_info_id,
                project_id,
                work_hours,
                work_days
            );

            if (data.statusCode === 200) {
                handleAttendanceDataGet();
                handleAttendanceEmployeeDataGet();
                handleCloseAttendanceModal();

                toast?.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `Attendance update successfully.`,
                    life: 3000,
                });
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value]) => (
                    showAPIErrorForAttandance(key, value[0])
                ));
            } else {
                toast?.current?.show({
                    severity: "error",
                    summary: "Failed",
                    detail: "There was an error updating the attendance.",
                    life: 3000,
                });
            }
        } catch (error) {
            console.error("Error updating the attendance:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while updating the attendance.",
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    }

    // Delete attendance
    const handleDeleteAttendance = (attendance: AttendanceData) => {
        const personalInfoId = attendance?.personal_info_id ?? null;
        const attendanceDate = attendance?.attendance_date ?? null;

        confirmDialog({
            message: 'Are you sure you want to delete this attendance details?',
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteAttendance(personalInfoId, attendanceDate),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    const deleteAttendance = async (personalInfoId: number | null, attendanceDate: string | null) => {
        if (!personalInfoId || !attendanceDate) return;

        setAttendanceDeleteLoadingId(personalInfoId);

        try {
            const data = await deleteAttendanceDataNew(
                personalInfoId,
                attendanceDate
            );

            if (data.statusCode === 200) {
                handleAttendanceDataGet();
                handleAttendanceEmployeeDataGet();

                toast?.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `Attendance deleted successfully.`,
                    life: 3000,
                });
            } else {
                toast?.current?.show({
                    severity: "error",
                    summary: "failed",
                    detail: "An error occurred while deleting the attendance data.",
                    life: 3000,
                });
            }
        } catch (error) {
            console.error("Error deleting the attendance data:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while deleting the attendance data.",
                life: 3000,
            });
        } finally {
            setAttendanceDeleteLoadingId(null);
        }
    }

    const attandanceModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState} attandance - <span className="custom">{dateFilter ? format(dateFilter, 'dd MMM yyyy') : ''}</span>
                {dataState === 'Edit' && selectedAttendanceData?.personalInfo?.first_name && (
                    <small className="modal_sub_title">
                        {(selectedAttendanceData?.personalInfo?.first_name ?? '') + ' ' + (selectedAttendanceData?.personalInfo?.last_name ?? '')}
                    </small>
                )}
            </h5>
            <button
                type="button"
                className="close_modal_btn p-ripple"
                onClick={handleCloseAttendanceModal}
            >
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    const attandanceModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseAttendanceModal}
            />

            <Button
                label={`${loading ? "Processing" : dataState === "Add" ? "Save" : "Update"}`}
                onClick={dataState === "Add" ? handleCreateAttendance : handleUpdateAttendance}
                loading={loading}
                disabled={dataState === 'Edit' && !attendanceUpdateHasChanges}
                className="custom_btn primary"
            />
        </div>
    );

    // View attendance
    const handleViewAttendance = (attendance: AttendanceData, dayAttendance: AttendanceDayView) => {
        setSelectedAttendanceData(attendance ?? null);
        setSelectedDayAttendanceData(dayAttendance ?? null);
        setShowAttendanceViewModal(true);
    }

    const handleCloseAttendanceViewModal = () => {
        setShowAttendanceViewModal(false);
        setSelectedAttendanceData(null);
        setSelectedDayAttendanceData(null);
    }

    const attendanceViewModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Attendance details
                {selectedAttendanceData?.personalInfo?.first_name && (
                    <small className="modal_sub_title">
                        {selectedAttendanceData?.personalInfo?.first_name}
                    </small>
                )}
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseAttendanceViewModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    )

    const dayAttendanceTableActionBody = (rowData: AttendanceData, dayAttendance: AttendanceDayView) => {
        const data = rowData;
        const dayData = dayAttendance;
        const isLoading = attendanceDeleteLoadingId === data?.personal_info_id;

        return (
            <React.Fragment>
                <div className="tabel_btn_area custom mt-1 mb-1">
                    <TableActionButton
                        icon="bi bi-eye"
                        onClick={() => handleViewAttendance(data, dayData)}
                        className="primary_table_btn"
                        tooltipTarget={`view_${data?.personal_info_id}`}
                        tooltip="View attendance detail"
                        tooltipPosition="left"
                    />

                    {hasPermissionEditAttendance && (
                        <TableActionButton
                            icon={`bi bi-pencil-square`}
                            onClick={() => handleEditAttendance(data, dayData)}
                            className="primary_table_btn"
                            tooltipTarget={`edit_${data?.personal_info_id}`}
                            tooltip="Edit attendance"
                            tooltipPosition="left"
                        />
                    )}

                    {hasPermissionDeleteAttendance && (
                        <TableActionButton
                            icon={`${isLoading ? 'bi bi-arrow-repeat loading_spinner' : 'bi bi-trash3'}`}
                            onClick={() => handleDeleteAttendance(data)}
                            className="danger_table_btn"
                            tooltipTarget={`delete_${data?.personal_info_id}`}
                            disabled={isLoading}
                            tooltip="Delete attendance"
                            tooltipPosition="left"
                        />
                    )}
                </div>
            </React.Fragment>
        )
    }
    /* **************************************************************** */


    /* **************************************************************** Attandance staff view */
    const handleResetStaffPaymentFields = () => {
        setStaffPaymentDate(null);
        setStaffPaymentAmount(null);
        setPaymentExpense(null);

        setSelectedStaffPaidData(null);

        setStaffPaymentDateError('');
        setStaffPaymentAmountError('');
        setPaymentExpenseError('');
    }

    const handleCloseStaffPaymentModal = () => {
        setShowStaffPaymentModal(false);
        handleResetStaffPaymentFields();

        if (dataState === 'Edit') {
            setShowStaffViewDetailModal(true);
        }
    }

    // Check Validation
    function checkCredentialsForStaffPayment(): boolean {
        const isValidPaymentStaff = checkModelSelected(staffFilter !== null, true, setPaymentStaffError);
        const isValidPaymentExpense = checkModelSelected(paymentExpense !== null, true, setPaymentExpenseError);
        const isValidPaymentDate = checkText(formatDate(staffPaymentDate ?? null), true, setStaffPaymentDateError);
        const isValidPaymentAmount = checkNumber(staffPaymentAmount!, true, setStaffPaymentAmountError);

        return (
            isValidPaymentStaff &&
            isValidPaymentExpense &&
            isValidPaymentDate &&
            isValidPaymentAmount);
    }

    // API validation
    function showAPIErrorForStaffPayment(keyName: string, error: string): void {
        if (keyName === "personal_info_id") {
            setPaymentStaffError(error);
        }

        if (keyName === "expense_id") {
            setPaymentExpenseError(error);
        }

        if (keyName === "date") {
            setStaffPaymentDateError(error);
        }

        if (keyName === "payed_amount") {
            setStaffPaymentAmountError(error);
        }
    }

    // Add staff payment
    const handleAddStaffPayment = () => {
        setStaffPaymentDate(today);

        if (expenses?.length > 0) {
            setPaymentExpense(expenses[0]);
        } else {
            setPaymentExpense(null);
        }

        setDataState('Add');
        setShowStaffPaymentModal(true);
    };

    // Staff payment create API
    const handleCreateStaffPayment = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForStaffPayment() || staffFilter === null) return;

        setLoading(true);

        try {
            const date = formatDate(staffPaymentDate ?? null) ?? null;
            const expense_id = paymentExpense?.id ?? null;
            const personal_info_id = staffFilter?.attenanceEmployee?.personal_info_id ?? null;
            const payed_amount = staffPaymentAmount ?? null;

            const data = await addAttendanceStaffPaymentNew(
                date,
                expense_id,
                personal_info_id,
                payed_amount
            );

            if (data.statusCode === 200) {
                handleAttendanceDataGet();
                handleStaffViewDetailGet();
                handleCloseStaffPaymentModal();

                toast?.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `Payment to ${staffFilter?.personalInfo?.first_name} was successfully added.`,
                    life: 3000,
                });
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value]) => (
                    showAPIErrorForStaffPayment(key, value[0])
                ));
            } else {
                toast?.current?.show({
                    severity: "error",
                    summary: "Failed",
                    detail: `There was an error adding the payment for ${staffFilter?.personalInfo?.first_name}.`,
                    life: 3000,
                });
            }
        } catch (error) {
            console.error(`Error adding the payment for ${staffFilter?.personalInfo?.first_name}:`, error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: `Something went wrong while adding the payment for ${staffFilter?.personalInfo?.first_name}.`,
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!selectedStaffPaidData) {
            setStaffPaymentUpdateHasChanges(false);
            return;
        }

        const hasChanges =
            formatDate(staffPaymentDate ?? null) !== selectedStaffPaidData?.date ||
            paymentExpense?.id !== selectedStaffPaidData?.expense_id ||
            staffPaymentAmount !== selectedStaffPaidData?.payed_amount;

        setStaffPaymentUpdateHasChanges(hasChanges);
    }, [selectedStaffPaidData, staffPaymentDate, paymentExpense, staffPaymentAmount]);

    // Edit staff payment
    const handleEditStaffPayment = (data: StaffPaidData) => {
        if (!data) return;

        setDataState('Edit');
        setShowStaffPaymentModal(true);
        setShowStaffViewDetailModal(false);

        setSelectedStaffPaidData(data);

        const existingExpense = expenses?.find(expense => expense.id === data.expense_id) || null;

        setStaffPaymentDate(parseStringToDate(data.date) ?? null);
        setPaymentExpense(existingExpense);
        setStaffPaymentAmount(data.payed_amount ?? null);
    };

    // Staff payment update API
    const handleUpdateStaffPayment = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForStaffPayment()) return;

        setLoading(true);

        try {
            const date = formatDate(staffPaymentDate ?? null) ?? null;
            const expense_id = paymentExpense?.id ?? null;
            const personal_info_id = staffFilter?.attenanceEmployee?.personal_info_id ?? null;
            const payed_amount = staffPaymentAmount ?? null;

            const data = await updateAttendanceStaffPaymentNew(
                date,
                expense_id,
                personal_info_id,
                payed_amount
            );

            if (data.statusCode === 200) {
                handleAttendanceDataGet();
                handleStaffViewDetailGet();
                handleCloseStaffPaymentModal();

                toast?.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `Payment to ${staffFilter?.personalInfo?.first_name} was successfully updated.`,
                    life: 3000,
                });
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value]) => (
                    showAPIErrorForStaffPayment(key, value[0])
                ));
            } else {
                toast?.current?.show({
                    severity: "error",
                    summary: "Failed",
                    detail: `There was an error updating the payment for ${staffFilter?.personalInfo?.first_name}.`,
                    life: 3000,
                });
            }
        } catch (error) {
            console.error(`Error updating the payment for ${staffFilter?.personalInfo?.first_name}:`, error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: `Something went wrong while updating the payment for ${staffFilter?.personalInfo?.first_name}.`,
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    }

    // Delete staff payment
    const handleDeleteStaffPayment = (data: StaffPaidData) => {
        if (!data) return;

        confirmDialog({
            message: 'Are you sure you want to delete this payment details?',
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteStaffPayment(data),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Staff payment delete API
    const deleteStaffPayment = async (paymentData: StaffPaidData) => {
        if (!paymentData) return;

        setStaffPaymentDeleteLoadingId(paymentData?.id);

        try {
            const date = paymentData?.date;
            const expense_id = paymentData?.expense_id;
            const personal_info_id = paymentData?.personal_info_id;

            const data = await deleteAttendanceStaffPaymentNew(
                date,
                expense_id,
                personal_info_id
            );

            if (data.statusCode === 200) {
                handleAttendanceDataGet();
                handleStaffViewDetailGet();

                toast?.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `Payment deleted successfully.`,
                    life: 3000,
                });
            } else {
                toast?.current?.show({
                    severity: "error",
                    summary: "failed",
                    detail: "An error occurred while deleting the payment data.",
                    life: 3000,
                });
            }
        } catch (error) {
            console.error("Error deleting the payment data:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while deleting the payment data.",
                life: 3000,
            });
        } finally {
            setStaffPaymentDeleteLoadingId(null);
        }
    }

    const staffPaymentModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">{dataState} payment -&nbsp;
                <span className="text-capitalize">
                    {staffFilter?.personalInfo?.first_name ?? ''}&nbsp;
                    {staffFilter?.personalInfo?.last_name ?? ''}&nbsp;
                </span>

                {dataState === 'Edit' && (
                    <small className="modal_sub_title">
                        {selectedStaffPaidData?.date ?? ''}
                    </small>
                )}
            </h5>

            <button
                type="button"
                className="close_modal_btn p-ripple"
                onClick={handleCloseStaffPaymentModal}
            >
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    )

    const staffPaymentModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseStaffPaymentModal}
            />

            <Button
                label={`${loading ? "Processing" : dataState === "Add" ? "Save" : "Update"}`}
                onClick={dataState === "Add" ? handleCreateStaffPayment : handleUpdateStaffPayment}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !staffPaymentUpdateHasChanges}
            />
        </div>
    )

    const toggleExpandExpense = (id: number) => {
        setExpandedExpenseIds(prev =>
            prev.includes(id)
                ? prev.filter(expandedId => expandedId !== id)
                : [...prev, id]
        );
    }

    const toggleExpandPaidData = () => {
        setExpandedPaidData(prev => !prev);
    }

    const getRowClassNameForStaffViewAttendance = (data: AttendanceStaffView, options: { [key: string]: any }) => {
        if (!data) return '';

        const hasAttendance = data?.project_data !== null;

        return `project_data_row secondary ${!hasAttendance ? 'disabled' : ''}`;
    }
    /* **************************************************************** */


    /* **************************************************************** Staff attendance/payment details */
    useEffect(() => {
        const fetchData = async () => {
            await handleStaffViewDetailGet();
        }

        fetchData();
    }, [staffFilter, staffSiteFilter, staffViewDetailMonthFilter, attendanceView]);

    const handleStaffViewDetailGet = async () => {
        if (!staffFilter) return;

        const staffId = staffFilter?.attenanceEmployee?.personal_info_id ?? null;
        const projectId = staffSiteFilter?.project_id ?? null;
        const yearMonth = staffViewDetailMonthFilter ? formatYearMonth(staffViewDetailMonthFilter) : null;

        let requestData: AttendanceViewDetailInput = {
            personal_info_id: staffId,
            project_id: projectId,
            year_month: yearMonth,
        }

        try {
            await dispatch(fetchAttendanceViewDetail(requestData));
        } catch (error) {
            toast?.current?.show({
                severity: 'error',
                summary: 'Failed',
                detail: 'There was an error fetching the detail.',
                life: 3000
            });
        }
    }

    const handleViewStaffDetail = () => {
        setShowStaffViewDetailModal(true);
    }

    const handleCloseStaffViewDetailModal = () => {
        setShowStaffViewDetailModal(false);
    }

    const staffViewDetailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5 text-capitalize">
                {staffDetailViewState} detail
            </h5>

            <button
                type="button"
                className="close_modal_btn p-ripple"
                onClick={handleCloseStaffViewDetailModal}
            >
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    // For staff attendance
    useEffect(() => {
        if (!viewDetail) {
            setHighlightedDates({});
            return;
        }

        const mapped: Record<string, string> = {};

        viewDetail.colour_dates?.forEach((item) => {
            if (item.date && item.colour_code) {
                const d = new Date(item.date);
                const key = d.toDateString();
                mapped[key] = item.colour_code;
            }
        });

        setHighlightedDates(mapped);

        if (viewDetail.month) {
            const [year, month] = viewDetail.month.split("-").map(Number);
            setViewDate(new Date(year, month - 1, 1));
        }
    }, [viewDetail]);

    const dateTemplate = (dateMeta: {
        day: number;
        month: number;
        year: number;
        today: boolean;
        selectable: boolean;
    }) => {
        const fullDate = new Date(dateMeta.year, dateMeta.month, dateMeta.day).toDateString();
        const backgroundColor = highlightedDates[fullDate] || "transparent";

        return (
            <div
                style={{
                    backgroundColor,
                    borderRadius: "8px",
                    width: "2.3rem",
                    height: "2.3rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: backgroundColor !== "transparent" ? "#fff" : "rgba(0,0,0,0.8)",
                    fontWeight: backgroundColor !== "transparent" ? 600 : 400,
                }}
                className={`date_grid_item ${backgroundColor !== "transparent" ? 'highlighted' : ''}`}
            >
                {dateMeta.day}
            </div>
        );
    };
    /* **************************************************************** */


    /* **************************************************************** Common */
    const employeeProfileBody = (rowData: AttendanceData) => {
        const info = rowData?.personalInfo;

        const profileImage = info?.profile_image;
        const firstName = info?.first_name ? info?.first_name : "";
        const lastName = info?.last_name ? info?.last_name : "";
        const profileNameLetters = firstName[0] + lastName[0];
        const fullName = info
            ? `${info.first_name ?? '---'}${info.last_name ? ' ' + info.last_name : ''}`
            : '---';

        return (
            <div className="employee_profile_display justify-content-start gap-3">
                <div className="employee_profile_image">
                    {profileImage !== null ? (
                        <img src={baseURL + profileImage} alt="Employee" />
                    ) : (
                        <span>{profileNameLetters}</span>
                    )}
                </div>

                <div>
                    <span className="employee_name">{fullName}</span>
                    {info?.email && <small className="text_muted d-block">{info.email}</small>}
                </div>
            </div>
        );
    };

    const handleNavigateEmployees = () => {
        navigate(`site-employees`, {
            state: { mainProject: rootProject ?? null }
        });
        goToTop();
    };

    const handleNavigateEmployeesWithState = () => {
        const navigateData: AttendanceNavigateData = {
            selectedDate: dateFilter,
            selectedProject: selectedAttendanceProject,
            selectedEmployees: selectedSiteEmployees,
            openStatus: true,
        }

        navigate(`site-employees`, {
            state: {
                mainProject: rootProject ?? null,
                navigateData: navigateData,
            }
        });
        goToTop();
    };
    /* **************************************************************** */


    /* **************************************************************** Share  */
    const handleCloseShareModal = () => {
        setShowContactShareModal(false);
    }

    const handleShareAttendance = () => {
        setShowContactShareModal(true);
        // setSelectedProject(project);
    }

    // database function
    const shareDataFunction = async (selectedContacts: ShareContactType[]) => {
        // get only ticked data as well
        // const sendData = selectedContacts.filter((e) => e.can_view !== 0 || e.can_edit !== 0)
        const sendData = selectedContacts.filter((e) => e.can_view !== 0)

        if ((sendData && sendData?.length > 0) || true) {
            setLoading(true);
            const data = await shareAttendanceNewAPI(
                sendData,
                siteFilter?.project_id!
            );

            setLoading(false);

            if (data.statusCode === 200) {
                dispatch(getAttendanceProjectNew());
                handleCloseShareModal();

                toast?.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Attendance shared successfully.',
                    life: 3000
                });
            } else {
                toast?.current?.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'There was an error sharing the attendance.',
                    life: 3000
                });
            }
        }
    }
    /* **************************************************************** */


    /* **************************************************************** Site employee */
    const [showSiteEmployeeModal, setShowSiteEmployeeModal] = useState<boolean>(false);
    const [siteEmployeeSearchKey, setSiteEmployeeSearchKey] = useState<string>("");
    const [allSiteEmployeesData, setAllSiteEmployeesData] = useState<SiteEmployeeType[]>([]);
    const [employeeStatusChangeLoadingId, setEmployeeStatusChangeLoadingId] = useState<number | null>(null);

    useEffect(() => {
        if (!siteEmployeesDB || siteEmployeesDB.length === 0) {
            setAllSiteEmployeesData([]);
            return;
        }

        const searchKey = siteEmployeeSearchKey.trim().toLowerCase();

        const filteredData = siteEmployeesDB.filter(employee => {
            if (!searchKey) return true;

            const firstName = employee?.personalInfo?.first_name?.toLowerCase() ?? '';
            const lastName = employee?.personalInfo?.last_name?.toLowerCase() ?? '';

            const fullName = `${firstName} ${lastName}`.trim();

            return (
                firstName.includes(searchKey) ||
                lastName.includes(searchKey) ||
                fullName.includes(searchKey)
            );
        });

        setAllSiteEmployeesData(filteredData);
    }, [siteEmployeesDB, siteEmployeeSearchKey]);

    const handleShowSiteEmployeeModal = () => {
        setShowEmployeeSelectModal(false);
        setShowSiteEmployeeModal(true);
    }

    const handleCloseSiteEmployeeModal = () => {
        setShowSiteEmployeeModal(false);
        setSiteEmployeeSearchKey("");
        setShowEmployeeSelectModal(true);
    }

    const siteEmployeeModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">Site Employees</h5>
            <button
                type="button"
                className="close_modal_btn p-ripple"
                onClick={handleCloseSiteEmployeeModal}
            >
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    const siteEmployeeModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseSiteEmployeeModal}
            />
        </div>
    );

    // Assign employee confirmation
    const handleModifySiteEmpoyeeList = (newStatus: boolean, employee: SiteEmployeeType) => {
        confirmDialog({
            message: `Do you want to ${newStatus === true ? 'add' : 'remove'} this employee from this attendance list?`,
            header: "Confirm Status Change",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            dismissableMask: true,
            resizable: false,
            draggable: false,
            accept: () => {
                modifySiteEmpoyeeList(newStatus, employee?.attenanceEmployee ?? null);
            },
        });
    }

    // Assign employee API
    const modifySiteEmpoyeeList = async (newStatus: boolean, employee: AttendanceEmployeeType | null) => {
        if (!employee) return;

        setEmployeeStatusChangeLoadingId(employee?.personal_info_id ?? null);

        try {
            const result = await activeAttendancesEmployeeNew(
                employee?.id ?? null
            );

            if (result.statusCode === 200) {
                toast?.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `Employee successfully ${newStatus ? 'added to' : 'removed from'} attendance list.`,
                    life: 3000,
                });

                handleCloseSiteEmployeeModal();

                dispatch(getAttendanceEmployeeList());
                handleAttendanceEmployeeDataGet();

                // remove if the employee is selected
                if (!newStatus) {
                    setSelectedSiteEmployees(prev =>
                        prev.filter(emp => emp.personalInfo?.id !== employee.personal_info_id)
                    );
                }
            } else {
                toast?.current?.show({
                    severity: "error",
                    summary: "Failed",
                    detail: `An error occurred while ${newStatus ? 'adding' : 'removing'} the employee ${newStatus ? 'to' : 'from'} the list.`,
                    life: 3000,
                });
            }
        } catch (error) {
            console.error(`Error ${newStatus ? 'adding' : 'removing'} the employee ${newStatus ? 'to' : 'from'} the list.:`, error);

            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: `Something went wrong while ${newStatus ? 'adding' : 'removing'} the employee ${newStatus ? 'to' : 'from'} the list.`,
                life: 3000,
            });
        } finally {
            setEmployeeStatusChangeLoadingId(null);
        }
    }

    // Table body
    const siteEmployeeNameBody = (rowData: SiteEmployeeType) => {
        const firstName = rowData?.personalInfo?.first_name
            ? rowData?.personalInfo?.first_name
            : "";
        const lastName = rowData?.personalInfo?.last_name
            ? rowData?.personalInfo?.last_name
            : "";

        return (
            <span className="text_bold text-capitalize">
                {firstName + " " + lastName}
            </span>
        );
    };

    const employeeStatusBody = (rowData: SiteEmployeeType) => {
        return (
            <div className="input_switch_area">
                {employeeStatusChangeLoadingId === rowData?.attenanceEmployee?.personal_info_id ? (
                    <ProgressSpinner
                        className="table_action_loader"
                        style={{ width: '25px', height: '25px' }}
                        strokeWidth="8"
                        fill="transparent"
                        animationDuration="1s"
                    />
                ) : (
                    <InputSwitch
                        checked={rowData?.attenanceEmployee?.status === 1}
                        onChange={(e) => handleModifySiteEmpoyeeList(e.value, rowData)}
                    />
                )}
            </div>
        );
    };
    /* **************************************************************** */


    /* **************************************************************** Attendance employee */
    const [showEmployeeSelectModal, setShowEmployeeSelectModal] = useState<boolean>(false);
    const [employeesSearchKey, setEmployeesSearchKey] = useState<string>("");
    const [filteredEmployeesData, setFilteredEmployeesData] = useState<SiteEmployeeType[]>([]);
    const [bodyHeight, setBodyHeight] = useState<number | "auto">("auto");
    const employeeListBodyRef = useRef<HTMLDivElement>(null);

    const updateHeight = () => {
        const el = employeeListBodyRef.current;
        if (!el) return;

        setBodyHeight(el.offsetHeight - 115);
    };

    useEffect(() => {
        if (!showEmployeeSelectModal) return;

        updateHeight();
        window.addEventListener("resize", updateHeight);

        return () => {
            window.removeEventListener("resize", updateHeight);
        };
    }, [showEmployeeSelectModal, employeeListBodyRef.current]);


    useEffect(() => {
        if (!siteEmployeesData || siteEmployeesData.length === 0) {
            setFilteredEmployeesData([]);
            return;
        }

        const searchKey = employeesSearchKey.trim().toLowerCase();

        const filteredData = siteEmployeesData.filter(employee => {
            if (!searchKey) return true;

            const firstName = employee?.personalInfo?.first_name?.toLowerCase() ?? '';
            const lastName = employee?.personalInfo?.last_name?.toLowerCase() ?? '';

            const fullName = `${firstName} ${lastName}`.trim();

            return (
                firstName.includes(searchKey) ||
                lastName.includes(searchKey) ||
                fullName.includes(searchKey)
            );
        });

        setFilteredEmployeesData(filteredData);
    }, [siteEmployeesData, employeesSearchKey]);

    const handleCloseEmployeeSelectModal = () => {
        setShowEmployeeSelectModal(false);
        setShowAttendanceModal(true);
    }

    const handleShowEmployeeSelectModal = () => {
        setShowEmployeeSelectModal(true);
        setShowAttendanceModal(false);
    }

    /* Modal header */
    const employeeSelectModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">Select employees</h5>
            <button
                type="button"
                className="close_modal_btn p-ripple"
                onClick={handleCloseEmployeeSelectModal}
            >
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const employeeSelectModalFooter = (
        <div className="custom_modal_footer flex-column flex-sm-row justify-content-between w-100">
            <div className="d-flex gap-2 align-items-center">
                <Button
                    icon="bi bi-plus-circle"
                    label="More employee"
                    onClick={handleNavigateEmployeesWithState}
                    tooltip="Click to add more site employees"
                    tooltipOptions={{ position: 'top' }}
                    className="custom_btn primary_light"
                />

                <Button
                    icon="bi bi-person-add"
                    label="Site employee"
                    tooltip="Click to enable/disable site employees."
                    tooltipOptions={{ position: 'top' }}
                    onClick={handleShowSiteEmployeeModal}
                    className="custom_btn primary_light"
                />
            </div>

            <Button
                label="Ok"
                onClick={handleCloseEmployeeSelectModal}
                className="custom_btn primary"
            />
        </div>
    );

    const handleSelectEmployee = (employee: SiteEmployeeType) => {
        setSelectedSiteEmployees((prev) => {
            const exists = prev.some(
                (e) =>
                    e.attenanceEmployee?.personal_info_id ===
                    employee.attenanceEmployee?.personal_info_id
            );

            if (exists) {
                return prev.filter(
                    (e) =>
                        e.attenanceEmployee?.personal_info_id !==
                        employee.attenanceEmployee?.personal_info_id
                );
            }

            return [...prev, employee];
        });
    };

    const handleRemoveSelectedEmployee = (employee: SiteEmployeeType) => {
        setSelectedSiteEmployees((prev) =>
            prev.filter(
                (e) =>
                    e.attenanceEmployee?.personal_info_id !==
                    employee.attenanceEmployee?.personal_info_id
            )
        );
    }
    /* **************************************************************** */


    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {(dataLoading && initialDataLoading) ? (
                    <PageLoader />
                ) : dataError ? (
                    <ErrorPage errorMessage={dataError} />
                ) : (
                    <div className="page_content mt-0">
                        {location.pathname === "/attendance" ? (
                            <div className="d-flex align-items-center justify-content-between">
                                <h4 className="main_heading">Attendance</h4>
                                <GoBackButton />
                            </div>
                        ) : (
                            <div className="page_breadcrumb_area">
                                <ul className="page_breadcrumb">
                                    <li
                                        className="page_breadcrumb_item has_link has_child"
                                        onClick={() => navigate(-1)}
                                    >
                                        {rootProject ? (rootProject?.job_number + ": " + rootProject?.address) : ''}
                                    </li>
                                    <li className="page_breadcrumb_item active">Attendance</li>
                                </ul>
                                <GoBackButton />
                            </div>
                        )}

                        <div className="page_tab_header mt-3">
                            <div className="contact_tabs">
                                {attendanceViewOptions?.map((option) => (
                                    <div className="contact_tab_item" key={`attendance_${option}`}>
                                        <button
                                            className={`contact_tab_btn min_width status_tab ${attendanceView === option ? "active" : ''} p-ripple`}
                                            type="button"
                                            role="tab"
                                            onClick={() => handleSwitchAttendanceView(option)}
                                        >
                                            {option} View
                                            <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                        </button>
                                    </div>
                                ))}
                            </div>

                            <div className="page_action_area d-none d-sm-flex">
                                {(((siteFilter && siteFilter?.is_own_project) && attendanceView === 'Site') && canAddAttendance) && (
                                    <button
                                        className="add_data_link_btn custom p-ripple"
                                        onClick={handleShareAttendance}
                                    >
                                        <i className="bi bi-share-fill"></i>
                                        <span className="btn_text">Share</span>
                                        <Ripple />
                                    </button>
                                )}

                                {(canAddAttendance) && (
                                    <button
                                        className="add_data_link_btn fill p-ripple"
                                        onClick={handleNavigateEmployees}
                                    >
                                        <span>Site Employees</span>
                                        <i className="bi bi-box-arrow-up-right"></i>
                                        <Ripple />
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* Filters section */}
                        {attendanceView === 'Day' ? (
                            <div className="page_filter_area mt-sm-3 mt-2">
                                <div className="row px-2 px-sm-1 row-gap-2">
                                    <div className="col-5 col-sm-4 col-md-3 col-lg-2 px-1 px-sm-2">
                                        <div className="page_filter_group has_icon">
                                            <DatePicker
                                                key={`dateFilter`}
                                                id="dateFilter"
                                                labelHtmlFor="dateFilter"
                                                className="as_filter"
                                                value={dateFilter}
                                                maxDate={today}
                                                dateFormat="dd M yy"
                                                placeholder="Select date"
                                                onChange={setDateFilter}
                                                formGroupClassName="mb-0"
                                            />
                                            <i className="bi bi-calendar2-minus-fill"></i>
                                        </div>
                                    </div>

                                    <div className="col-7 col-sm-4 col-md-4 col-lg-3 px-1 px-sm-2">
                                        <div className="page_filter_group">
                                            <Dropdown
                                                key={`daySiteFilter`}
                                                id="daySiteFilter"
                                                value={daySiteFilter}
                                                onChange={
                                                    (e: DropdownChangeEvent) => setDaySiteFilter(e.value)}
                                                optionLabel="full_address"
                                                itemTemplate={(option: AttendanceProjectType) => {
                                                    return (
                                                        <span className="text-capitalize">
                                                            <span className="text_bold">{option?.job_number}</span>:&nbsp;{option?.full_address}
                                                        </span>
                                                    )
                                                }}
                                                valueTemplate={(option: AttendanceProjectType, props: DropdownProps) => {
                                                    if (option) {
                                                        return (
                                                            <span className="text-capitalize">
                                                                <span className="text_bold">{option?.job_number}</span>:&nbsp;{option?.address}
                                                            </span>
                                                        )
                                                    }

                                                    return <span>{props.placeholder}</span>;
                                                }}
                                                filter
                                                emptyFilterMessage="The project you were looking for is not found!"
                                                emptyMessage="No project(s) found!"
                                                filterBy="full_address,job_number"
                                                filterPlaceholder="Search by address/job no."
                                                options={siteOptionsData}
                                                panelClassName="status_option_panel text-capitalize"
                                                placeholder="Filter by project"
                                                className="form_dropdown as_filter w-100 text-capitalize"
                                                loading={projectLoading}
                                                showClear={rootProject === null}
                                                disabled={rootProject !== null || (siteOptionsData.length === 0 || siteOptionsData.length === 1)}
                                                readOnly={rootProject !== null}
                                                dropdownIcon={rootProject !== null || (siteOptionsData.length === 0 || siteOptionsData.length === 1)}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-4 col-md-5 col-lg-7 px-1 px-sm-2">
                                        <div className="page_action_area justify-content-end">
                                            <button
                                                className="add_data_link_btn fill p-ripple d-sm-none"
                                                onClick={handleNavigateEmployees}
                                            >
                                                <i className="bi bi-people"></i>
                                                <Ripple />
                                            </button>

                                            {hasPermissionAddAttendance && (
                                                <button
                                                    className="add_data_link_btn p-ripple"
                                                    onClick={handleAddAttendance}
                                                >
                                                    <i className="bi bi-plus-circle"></i>
                                                    <span>Add attendance</span>
                                                    <Ripple />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        ) : attendanceView === 'Site' ? (
                            <div className="page_filter_area mt-sm-3 mt-2">
                                <div className="row px-2 px-sm-1 row-gap-2">
                                    {/* Site filter */}
                                    <div className="col-6 col-sm-4 col-lg-3 px-1 px-sm-2">
                                        <div className="page_filter_group">
                                            <Dropdown
                                                key={`siteFilter`}
                                                id="siteFilter"
                                                value={siteFilter}
                                                onChange={(e: DropdownChangeEvent) => setSiteFilter(e.value)}
                                                optionLabel="full_address"
                                                itemTemplate={(option: AttendanceProjectType) => {
                                                    return (
                                                        <span className="text-capitalize">
                                                            <span className="text_bold">{option?.job_number}</span>:&nbsp;{option?.full_address}
                                                        </span>
                                                    )
                                                }}
                                                valueTemplate={(option: AttendanceProjectType, props: DropdownProps) => {
                                                    if (option) {
                                                        return (
                                                            <span className="text-capitalize">
                                                                <span className="text_bold">{option?.job_number}</span>:&nbsp;{option?.address}
                                                            </span>
                                                        )
                                                    }

                                                    return <span>{props.placeholder}</span>;
                                                }}
                                                filter
                                                emptyFilterMessage="The project you were looking for is not found!"
                                                emptyMessage="No project(s) found!"
                                                filterBy="full_address,job_number"
                                                filterPlaceholder="Search by address/job no."
                                                options={siteOptionsData}
                                                panelClassName="status_option_panel text-capitalize"
                                                placeholder="Filte by project"
                                                className="form_dropdown as_filter w-100 text-capitalize"
                                                loading={projectLoading}
                                                disabled={rootProject !== null || (siteOptionsData.length === 0 || siteOptionsData.length === 1)}
                                                dropdownIcon={rootProject !== null || (siteOptionsData.length === 0 || siteOptionsData.length === 1)}
                                            />
                                        </div>
                                    </div>

                                    {/* Employees filter */}
                                    <div className="col-6 col-sm-4 col-lg-3 px-1 px-sm-2">
                                        <div className="page_filter_group">
                                            <Dropdown
                                                key="siteEmployeeFilter"
                                                id="siteEmployeeFilter"
                                                value={siteEmployeeFilter}
                                                onChange={(e: DropdownChangeEvent) => setSiteEmployeeFilter(e.value)}
                                                optionLabel="personalInfo.first_name"
                                                options={siteEmployeeFilterOptionsData}
                                                loading={siteEmployeeLoading}
                                                filter
                                                filterBy="personalInfo.first_name,personalInfo.last_name"
                                                filterPlaceholder="Search employee by name"
                                                emptyFilterMessage="The employee you were looking for is not found!"
                                                emptyMessage="No employee(s) found!"
                                                placeholder="Filter by employee"
                                                panelClassName="status_option_panel text-capitalize"
                                                className="form_dropdown as_filter w-100 text-capitalize"

                                                itemTemplate={(option: SiteEmployeeType) => {
                                                    const info = option?.personalInfo;
                                                    const fullName = info
                                                        ? `${info.first_name ?? '---'}${info.last_name ? ' ' + info.last_name : ''}`
                                                        : '---';

                                                    return (
                                                        <span className="text-capitalize">{fullName}</span>
                                                    );
                                                }}

                                                valueTemplate={(option: SiteEmployeeType, props: DropdownProps) => {
                                                    if (option) {
                                                        const info = option.personalInfo;
                                                        const fullName = info
                                                            ? `${info.first_name ?? '---'}${info.last_name ? ' ' + info.last_name : ''}`
                                                            : '---';

                                                        return (
                                                            <span className="text-capitalize">{fullName}</span>
                                                        );
                                                    }
                                                    return <span>{props.placeholder}</span>;
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* Start date filter */}
                                    <div className="col-6 col-sm-4 col-lg-3 px-1 px-sm-2">
                                        <div className="page_filter_group has_icon">
                                            <DatePicker
                                                key={`startDateFilter`}
                                                id="startDateFilter"
                                                labelHtmlFor="startDateFilter"
                                                className="as_filter"
                                                value={startDateFilter}
                                                maxDate={today}
                                                placeholder="Start date"
                                                onChange={setStartDateFilter}
                                                formGroupClassName="mb-0"
                                            />
                                            <i className="bi bi-calendar2-range"></i>
                                        </div>
                                    </div>

                                    {/* End date filter */}
                                    <div className="col-6 col-sm-4 col-lg-3 px-1 px-sm-2">
                                        <div className="page_filter_group has_icon">
                                            <DatePicker
                                                key={`endDateFilter`}
                                                id="endDateFilter"
                                                labelHtmlFor="endDateFilter"
                                                className="as_filter"
                                                value={endDateFilter}
                                                minDate={startDateFilter ?? today}
                                                maxDate={today}
                                                placeholder="End date"
                                                onChange={setEndDateFilter}
                                                formGroupClassName="mb-0"
                                            />
                                            <i className="bi bi-calendar2-range"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <React.Fragment>
                                <div className="page_filter_area mt-sm-3 mt-2">
                                    <div className="row px-2 px-sm-1 row-gap-2">
                                        {/* Staffs filter */}
                                        <div className="col-6 col-sm-4 col-lg-3 px-1 px-sm-2">
                                            <div className="page_filter_group">
                                                <Dropdown
                                                    key="staffFilter"
                                                    id="staffFilter"
                                                    value={staffFilter}
                                                    onChange={(e: DropdownChangeEvent) => setStaffFilter(e.value)}
                                                    optionLabel="personalInfo.first_name"
                                                    options={staffFilterOptionsData}
                                                    loading={siteEmployeeLoading}
                                                    filter
                                                    filterBy="personalInfo.first_name,personalInfo.last_name"
                                                    filterPlaceholder="Search staff by name"
                                                    emptyFilterMessage="The staff you were looking for is not found!"
                                                    emptyMessage="No staff(s) found!"
                                                    placeholder="Filter by staff"
                                                    panelClassName="status_option_panel text-capitalize"
                                                    className="form_dropdown as_filter w-100 text-capitalize"

                                                    itemTemplate={(option: SiteEmployeeType) => {
                                                        const info = option?.personalInfo;
                                                        const fullName = info
                                                            ? `${info.first_name ?? '---'}${info.last_name ? ' ' + info.last_name : ''}`
                                                            : '---';

                                                        return (
                                                            <span className="text-capitalize">{fullName}</span>
                                                        );
                                                    }}

                                                    valueTemplate={(option: SiteEmployeeType, props: DropdownProps) => {
                                                        if (option) {
                                                            const info = option.personalInfo;
                                                            const fullName = info
                                                                ? `${info.first_name ?? '---'}${info.last_name ? ' ' + info.last_name : ''}`
                                                                : '---';

                                                            return (
                                                                <span className="text-capitalize">{fullName}</span>
                                                            );
                                                        }
                                                        return <span>{props.placeholder}</span>;
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Site filter */}
                                        <div className="col-6 col-sm-4 col-lg-3 px-1 px-sm-2">
                                            <div className="page_filter_group">
                                                <Dropdown
                                                    key={`staffSiteFilter`}
                                                    id="staffSiteFilter"
                                                    value={staffSiteFilter}
                                                    onChange={(e: DropdownChangeEvent) => setStaffSiteFilter(e.value)}
                                                    optionLabel="full_address"
                                                    itemTemplate={(option: AttendanceProjectType) => {
                                                        return (
                                                            <span className="text-capitalize">
                                                                <span className="text_bold">
                                                                    {option?.job_number ? `${option?.job_number}: ` : ''}
                                                                </span>
                                                                {option?.full_address}
                                                            </span>
                                                        )
                                                    }}
                                                    valueTemplate={(option: AttendanceProjectType, props: DropdownProps) => {
                                                        if (option) {
                                                            return (
                                                                <span className="text-capitalize">
                                                                    <span className="text_bold">
                                                                        {option?.job_number ? `${option?.job_number}: ` : ''}
                                                                    </span>
                                                                    {option?.address}
                                                                </span>
                                                            )
                                                        }

                                                        return <span>{props.placeholder}</span>;
                                                    }}
                                                    filter
                                                    emptyFilterMessage="The project you were looking for is not found!"
                                                    emptyMessage="No project(s) found!"
                                                    filterBy="full_address,job_number"
                                                    filterPlaceholder="Search by address/job no."
                                                    options={staffSiteOptionsData}
                                                    panelClassName="status_option_panel text-capitalize"
                                                    placeholder="Filte by project"
                                                    className="form_dropdown as_filter w-100 text-capitalize"
                                                    loading={projectLoading}
                                                    disabled={rootProject !== null || (staffSiteOptionsData.length === 0 || staffSiteOptionsData.length === 1)}
                                                    dropdownIcon={rootProject !== null || (staffSiteOptionsData.length === 0 || staffSiteOptionsData.length === 1)}
                                                />
                                            </div>
                                        </div>

                                        {/* Start date filter */}
                                        <div className="col-6 col-sm-4 col-lg-3 px-1 px-sm-2">
                                            <div className="page_filter_group has_icon">
                                                <DatePicker
                                                    key={`staffStartDateFilter`}
                                                    id="staffStartDateFilter"
                                                    labelHtmlFor="staffStartDateFilter"
                                                    className="as_filter"
                                                    value={staffStartDateFilter}
                                                    maxDate={today}
                                                    placeholder="Start date"
                                                    onChange={setStaffStartDateFilter}
                                                    formGroupClassName="mb-0"
                                                />
                                                <i className="bi bi-calendar2-range"></i>
                                            </div>
                                        </div>

                                        {/* End date filter */}
                                        <div className="col-6 col-sm-4 col-lg-3 px-1 px-sm-2">
                                            <div className="page_filter_group has_icon">
                                                <DatePicker
                                                    key={`staffEndDateFilter`}
                                                    id="staffEndDateFilter"
                                                    labelHtmlFor="staffEndDateFilter"
                                                    className="as_filter"
                                                    value={staffEndDateFilter}
                                                    minDate={staffStartDateFilter ?? today}
                                                    maxDate={today}
                                                    placeholder="End date"
                                                    onChange={setStaffEndDateFilter}
                                                    formGroupClassName="mb-0"
                                                />
                                                <i className="bi bi-calendar2-range"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="page_tab_header justify-content-end mt-3">
                                    <div className="page_action_area justify-content-end">
                                        <button
                                            className="add_data_link_btn p-ripple"
                                            onClick={handleViewStaffDetail}
                                        >
                                            <i className="bi bi-eye"></i>
                                            <span>View detail</span>
                                            <Ripple />
                                        </button>

                                        {/* Add staff payment */}
                                        {hasPermissionAddStaffPayment && (
                                            <button
                                                className="add_data_link_btn p-ripple"
                                                onClick={handleAddStaffPayment}
                                            >
                                                <i className="bi bi-plus-circle"></i>
                                                <span>Add payment</span>
                                                <Ripple />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </React.Fragment>
                        )}

                        <div className="page_main_content_section">
                            {dataLoading && (
                                (attendanceView === 'Day' && attendanceDayData?.length === 0) ||
                                (attendanceView === 'Site' && attendanceSiteData?.length === 0) ||
                                (attendanceView === 'Staff' && attendanceStaffData?.length === 0)
                            ) && (
                                    <CustomTableLoader />
                                )}

                            {attendanceView === 'Day' ? (
                                (attendanceDayData && attendanceDayData?.length > 0 ? (
                                    <React.Fragment>
                                        {attendanceDayData?.map((dayAttendance, index) => {
                                            return (
                                                <div key={`dayAttendance_${index}`} className="page_sub_content_section">
                                                    <div className="page_sub_content_header">
                                                        <h4 className="page_sub_content_head text-capitalize">
                                                            <i className="bi bi-geo-alt me-2"></i>
                                                            {dayAttendance?.full_address}
                                                        </h4>

                                                        <div className="page_sub_content_header_btn_area">
                                                            <span className="sub_content_badge">
                                                                {String(dayAttendance?.data_count ?? 0).padStart(2, '0')}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="page_sub_content_body">
                                                        {dayAttendance?.data && dayAttendance?.data?.length > 0 ? (
                                                            <DataTable
                                                                key={`dayAttendanceProject_${dayAttendance?.project_id}`}
                                                                value={dayAttendance?.data}
                                                                size="small"
                                                                dataKey="personal_info_id"
                                                                className="page_table fs_data_table p-0"
                                                                rowClassName={() => 'project_data_row secondary'}
                                                                rowHover
                                                                scrollable
                                                                tableStyle={{ minWidth: "50rem" }}
                                                                scrollHeight="490px"
                                                                loading={dataLoading}
                                                                emptyMessage="No attendance data available!"
                                                            >
                                                                <Column
                                                                    header="Employee"
                                                                    headerClassName="text_purple"
                                                                    body={employeeProfileBody}
                                                                    style={{ width: "40%" }}
                                                                ></Column>

                                                                <Column
                                                                    header="Designation"
                                                                    headerClassName="text_purple"
                                                                    field="userRoleInfo.role_name"
                                                                    body={(rowData: AttendanceData) => (
                                                                        <span className="text-capitalize">
                                                                            {rowData?.userRoleInfo?.role_name
                                                                                ? rowData?.userRoleInfo?.role_name
                                                                                : "---"}
                                                                        </span>
                                                                    )}
                                                                    style={{ width: "20%" }}
                                                                ></Column>

                                                                <Column
                                                                    header="Duration"
                                                                    alignHeader="center"
                                                                    field="work_hours"
                                                                    headerClassName="text_purple"
                                                                    body={(rowData: AttendanceData) => {
                                                                        const { work_days = 0, work_hours = 0 } = rowData;

                                                                        const isDayType = work_hours === 0 && work_days > 0;
                                                                        const isHourType = work_days === 0 && work_hours > 0;

                                                                        return (
                                                                            <span className="flex_center">
                                                                                {isDayType
                                                                                    ? `${String(work_days).padStart(2, '0')} day${work_days > 1 ? 's' : ''}`
                                                                                    : isHourType
                                                                                        ? `${String(work_hours).padStart(2, '0')} hour${work_hours > 1 ? 's' : ''}`
                                                                                        : "---"}
                                                                            </span>
                                                                        );
                                                                    }}
                                                                    style={{ width: "10%" }}
                                                                />

                                                                <Column
                                                                    body={(rowData: AttendanceData) => dayAttendanceTableActionBody(rowData, dayAttendance)}
                                                                    frozen={window.innerWidth > 575}
                                                                    alignFrozen="right"
                                                                    style={{ width: "30%" }}
                                                                ></Column>
                                                            </DataTable>
                                                        ) : (
                                                            <NoDataCreated
                                                                containerClassname="pos_rel sub"
                                                                message={`No attendance added in ${dayAttendance?.full_address}. ${hasPermissionAddAttendance ? 'Click the Add button to add the attendance.' : ''}`}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </React.Fragment>
                                ) : (
                                    <NoDataCreated message={`Attendance not added`} />
                                ))
                            ) : attendanceView === 'Site' ? (
                                (attendanceSiteData && attendanceSiteData?.length > 0 ? (
                                    <React.Fragment>
                                        {attendanceSiteData?.map((siteAttendance, index) => {
                                            return (
                                                <div key={`siteAttendance_${index}`} className="page_sub_content_section">
                                                    <div className="page_sub_content_header custom">
                                                        <h4 className="page_sub_content_head text-capitalize">
                                                            <i className="bi bi-calendar2-event me-2"></i>
                                                            {siteAttendance?.date}
                                                        </h4>

                                                        <div className="page_sub_content_header_btn_area">
                                                            <span className="sub_content_badge">
                                                                {String(siteAttendance?.data_count ?? 0).padStart(2, '0')}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="page_sub_content_body">
                                                        {siteAttendance?.data && siteAttendance?.data?.length > 0 ? (
                                                            <DataTable
                                                                key={`siteAttendanceDate_${siteAttendance?.date}`}
                                                                value={siteAttendance?.data}
                                                                size="small"
                                                                dataKey="personal_info_id"
                                                                className="page_table fs_data_table p-0"
                                                                rowClassName={() => 'project_data_row secondary'}
                                                                rowHover
                                                                scrollable
                                                                tableStyle={{ minWidth: "50rem" }}
                                                                scrollHeight="490px"
                                                                loading={dataLoading}
                                                                emptyMessage="No attendance data available!"
                                                            >
                                                                <Column
                                                                    header="Employee"
                                                                    headerClassName="text_purple"
                                                                    body={employeeProfileBody}
                                                                    style={{ width: "40%" }}
                                                                ></Column>

                                                                <Column
                                                                    header="Designation"
                                                                    headerClassName="text_purple"
                                                                    field="userRoleInfo.role_name"
                                                                    body={(rowData: AttendanceData) => (
                                                                        <span className="text-capitalize">
                                                                            {rowData?.userRoleInfo?.role_name
                                                                                ? rowData?.userRoleInfo?.role_name
                                                                                : "---"}
                                                                        </span>
                                                                    )}
                                                                    style={{ width: "40%" }}
                                                                ></Column>

                                                                <Column
                                                                    header="Working hours"
                                                                    alignHeader={'center'}
                                                                    field="work_hours"
                                                                    headerClassName="text_purple"
                                                                    body={(rowData: AttendanceData) => (
                                                                        <span className="flex_center">
                                                                            {rowData?.work_hours ? String(rowData?.work_hours).padStart(2, '0') : "---"}
                                                                        </span>
                                                                    )}
                                                                    style={{ width: "20%" }}
                                                                ></Column>
                                                            </DataTable>
                                                        ) : (
                                                            <NoDataCreated
                                                                containerClassname="pos_rel sub"
                                                                message={`No attendance data found!`}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </React.Fragment>
                                ) : (
                                    <NoDataCreated message={`Attendance data not found`} />
                                ))
                            ) : attendanceView === 'Staff' ? (
                                (attendanceStaffData && attendanceStaffData?.length > 0 ? (
                                    <div className="page_sub_content_section">
                                        <DataTable
                                            key={`attendanceStaffView`}
                                            value={attendanceStaffData}
                                            size="small"
                                            dataKey="month"
                                            className="page_table fs_data_table align_middle p-0"
                                            rowClassName={getRowClassNameForStaffViewAttendance}
                                            rowHover
                                            loading={dataLoading}
                                            scrollable
                                            tableStyle={{ minWidth: "50rem" }}
                                            emptyMessage="No attendance data available!"
                                        >
                                            <Column
                                                header="Date"
                                                headerClassName="text_purple"
                                                field="date"
                                                body={(rowData: AttendanceStaffView) => (
                                                    <span className="text-capitalize text_no_wrap text_semi_bold">
                                                        {rowData?.date ?? '---'}
                                                    </span>
                                                )}
                                                style={{ width: "16%" }}
                                            ></Column>

                                            <Column
                                                header="Site"
                                                headerClassName="text_purple"
                                                field="project_data.full_address"
                                                body={(rowData: AttendanceStaffView) => (
                                                    <span className="text-capitalize">
                                                        {rowData?.project_data?.full_address ?? '---'}
                                                    </span>
                                                )}
                                                style={{ width: "20%" }}
                                            ></Column>

                                            <Column
                                                header="Hours"
                                                alignHeader={'center'}
                                                field="total_hours"
                                                headerClassName="text_purple"
                                                body={(rowData: AttendanceStaffView) => (
                                                    <span className="text-capitalize flex_center text_no_wrap">
                                                        {rowData?.total_hours !== null ? rowData?.total_hours : '---'}
                                                    </span>
                                                )}
                                                style={{ width: "8%" }}
                                            ></Column>

                                            <Column
                                                header="Days"
                                                alignHeader={'center'}
                                                field="total_days"
                                                headerClassName="text_purple"
                                                body={(rowData: AttendanceStaffView) => (
                                                    <span className="text-capitalize flex_center text_no_wrap">
                                                        {rowData?.total_days !== null ? rowData?.total_days : '---'}
                                                    </span>
                                                )}
                                                style={{ width: "8%" }}
                                            ></Column>

                                            <Column
                                                header="Wages"
                                                alignHeader={'right'}
                                                field="total_wage"
                                                headerClassName="text_purple"
                                                body={(rowData: AttendanceStaffView) => (
                                                    <span className="flex_end text_no_wrap">
                                                        {rowData?.total_wage !== null ? amountDisplay(rowData?.total_wage ?? 0) : "---"}
                                                    </span>
                                                )}
                                                style={{ width: "16%" }}
                                            ></Column>

                                            <Column
                                                header="Other Expense"
                                                alignHeader={'right'}
                                                field="other_expense_amount"
                                                headerClassName="text_purple"
                                                body={(rowData: AttendanceStaffView) => (
                                                    <span className="flex_end text_no_wrap">
                                                        {rowData?.other_expense_amount !== null ? amountDisplay(rowData?.other_expense_amount ?? 0) : "---"}
                                                    </span>
                                                )}
                                                style={{ width: "16%" }}
                                            ></Column>

                                            <Column
                                                header="Paid"
                                                alignHeader={'right'}
                                                field="total_paid"
                                                headerClassName="text_purple"
                                                body={(rowData: AttendanceStaffView) => (
                                                    <span className="flex_end text_no_wrap text_bold">
                                                        {rowData?.total_paid !== null ? amountDisplay(rowData?.total_paid ?? 0) : "---"}
                                                    </span>
                                                )}
                                                style={{ width: "16%" }}
                                            ></Column>
                                        </DataTable>
                                    </div>
                                ) : (
                                    <NoDataCreated message={`
                                        ${staffFilter?.personalInfo?.first_name ?? ''} ${staffFilter?.personalInfo?.last_name ?? ''}'s
                                        attendance record data is not available.`} />
                                ))
                            ) : null}
                        </div>
                    </div>
                )}
            </div>


            {/* Employees selection modal */}
            <Dialog
                visible={showEmployeeSelectModal}
                header={employeeSelectModalHeader}
                footer={employeeSelectModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm assign_contact_modal"
                onHide={handleCloseEmployeeSelectModal}
                dismissableMask
            >
                <div className="custom_modal_body fixed_height" ref={employeeListBodyRef}>
                    {siteEmployeeLoading ? (
                        <CustomTableLoader />
                    ) : siteEmployeeError ? (
                        <div className="data_select_modal_body">
                            <DataException
                                message={siteEmployeeError}
                            />
                        </div>
                    ) : (
                        <div className="pt-0 px-sm-0 px-1 pb-2 w-100">
                            <div className="share_contact_tab_header">
                                <div className="data_search_input_area contact_search mt-0">
                                    <InputText
                                        key={"employeesSearchKey"}
                                        id="employeesSearchKey"
                                        value={employeesSearchKey}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                            setEmployeesSearchKey(e.target.value)
                                        }
                                        className="custom_form_input data_search_input"
                                        placeholder="Search contact by name"
                                        autoComplete="off"
                                        autoFocus
                                        type={"search"}
                                    />
                                    {employeesSearchKey === "" ? (
                                        <i className="bi bi-search"></i>
                                    ) : (
                                        <i
                                            className="bi bi-x-lg data_search_input_clear"
                                            onClick={() => setEmployeesSearchKey('')}
                                        ></i>
                                    )}
                                </div>
                            </div>

                            <div className="row">
                                {filteredEmployeesData?.length > 0 ? (
                                    <div className="col-12">
                                        <ul className="assign_contact_list_area mt-sm-2 ps-sm-4 pe-sm-4 mb-sm-3 mb-2">
                                            {filteredEmployeesData.map((employee) => {
                                                const isEmployeeSelected = selectedSiteEmployees.some(selectedEmployee => selectedEmployee?.personalInfo?.id === employee?.personalInfo?.id);

                                                return (
                                                    <li className="assign_contact_list w-100">
                                                        <Checkbox
                                                            onChange={(e) => handleSelectEmployee(employee)}
                                                            checked={isEmployeeSelected}
                                                        ></Checkbox>

                                                        <button
                                                            className={`contact_slide_tab assign_contact p-ripple ${isEmployeeSelected && "active"}`}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleSelectEmployee(employee);
                                                            }}
                                                        >
                                                            <Image
                                                                className="contact_profile_img"
                                                                src={`${baseURL}${employee?.personalInfo?.profile_image}`}
                                                                alt="Profile"
                                                            />
                                                            <div className="contact_slide_det">
                                                                <h6>
                                                                    {employee?.personalInfo?.first_name + " " + employee?.personalInfo?.last_name}
                                                                </h6>

                                                                {employee?.userRoleInfo?.role_name && (
                                                                    <p>{employee?.userRoleInfo?.role_name}</p>
                                                                )}

                                                                {employee?.personalInfo?.email && (
                                                                    <small>
                                                                        {employee?.personalInfo?.email}
                                                                    </small>
                                                                )}
                                                            </div>
                                                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                                        </button>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                ) : (
                                    <div className="col-12">
                                        <div className="no_data_found d-flex align-content-center flex-column justify-content-center mt-2 mb-2"
                                            style={{ height: bodyHeight }}>
                                            <h6>
                                                {employeesSearchKey
                                                    ? `No employee(s) found matching "${employeesSearchKey}".`
                                                    : `No employee(s) found!`}
                                            </h6>

                                            {siteEmployeesData?.length === 0 && (
                                                <button
                                                    className={`add_data_btn p-ripple mt-3 mx-auto`}
                                                    onClick={() => navigate('/contact')}
                                                >
                                                    <i className={`bi bi-box-arrow-up-left`}></i>
                                                    Site employees
                                                    <Ripple />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* Attendance modal */}
            <Dialog
                visible={showAttendanceModal}
                headerClassName="custom_modal_header"
                header={attandanceModalHeader}
                footer={attandanceModalFooter}
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseAttendanceModal}
            >
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-3 pt-sm-2 pb-sm-0 w-100">
                        <div className="row">
                            {attendanceDateError && (
                                <div className="col-12 mb-3">
                                    <Message
                                        severity="error"
                                        text={attendanceDateError}
                                        className="custom_form_msg"
                                    />
                                </div>
                            )}

                            {/* Project */}
                            <div className="col-12">
                                <div className="page_form_group">
                                    <label htmlFor="attendanceProject" className="custom_form_label is_required">Project</label>
                                    <Dropdown
                                        key={`attendanceProject`}
                                        id="attendanceProject"
                                        value={selectedAttendanceProject}
                                        onChange={(e: DropdownChangeEvent) => setSelectedAttendanceProject(e.value)}
                                        optionLabel="full_address"
                                        itemTemplate={(option: AttendanceProjectType) => {
                                            return (
                                                <span className="text-capitalize">
                                                    <span className="text_bold">{option?.job_number}</span>:&nbsp;{option?.full_address}
                                                </span>
                                            )
                                        }}
                                        valueTemplate={(option: AttendanceProjectType, props: DropdownProps) => {
                                            if (option) {
                                                return (
                                                    <span className="text-capitalize">
                                                        <span className="text_bold">{option?.job_number}</span>:&nbsp;{option?.full_address}
                                                    </span>
                                                )
                                            }

                                            return <span>{props.placeholder}</span>;
                                        }}
                                        filter
                                        emptyFilterMessage="The project you were looking for is not found!"
                                        emptyMessage="No project(s) found!"
                                        filterBy="full_address,job_number"
                                        filterPlaceholder="Filter by project address or job no."
                                        options={sitesData}
                                        panelClassName="status_option_panel"
                                        placeholder="Select project"
                                        className="form_dropdown w-100 text-capitalize"
                                        loading={projectLoading}
                                        disabled={rootProject !== null}
                                        dropdownIcon={rootProject !== null}
                                    />

                                    {attendanceProjectError &&
                                        <small className="form_error_msg">{attendanceProjectError}</small>
                                    }

                                    {projectError &&
                                        <small className="form_error_msg">{projectError}</small>
                                    }
                                </div>
                            </div>

                            {/* Employees */}
                            {dataState === 'Add' && (
                                <div className="col-12">
                                    <div className={`page_form_group ${dataState === 'Add' ? 'mb-3' : ''}`}>
                                        <label htmlFor="attendanceEmployees" className="custom_form_label is_required">
                                            Employees
                                        </label>

                                        <div className="data_chips_input">
                                            <div className="data_chips_container cursor_default">
                                                {selectedSiteEmployees && selectedSiteEmployees?.length > 0 ? (
                                                    <React.Fragment>
                                                        {selectedSiteEmployees?.map((employee, index) => {
                                                            return (
                                                                <span className="data_chip_label removable" key={index}>
                                                                    {employee?.personalInfo?.first_name ?? ''}

                                                                    <i className="bi bi-x-circle remove_chip_btn"
                                                                        onClick={() => handleRemoveSelectedEmployee(employee)}
                                                                    ></i>
                                                                </span>
                                                            )
                                                        })}
                                                    </React.Fragment>
                                                ) : (
                                                    <span className="placeholder_text">Click the button to select employees</span>
                                                )}
                                            </div>

                                            <button
                                                className="add_value_btn p-ripple"
                                                onClick={handleShowEmployeeSelectModal}
                                            >
                                                {selectedSiteEmployees?.length === 0 ? (
                                                    <React.Fragment>
                                                        <i className="bi bi-plus-lg"></i>
                                                        <span>Select</span>
                                                    </React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                        <i className="bi bi-pencil-square"></i>
                                                        <span>Change</span>
                                                    </React.Fragment>
                                                )}
                                                <Ripple />
                                            </button>
                                        </div>

                                        {siteEmployeesError && (
                                            <small className="form_error_msg">{siteEmployeesError}</small>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Working duration */}
                            {dataState === 'Edit' && selectedAttendanceData && (() => {
                                const { work_days = 0, work_hours = 0 } = selectedAttendanceData;

                                const isDayType = work_hours === 0 && work_days > 0;
                                const isHourType = work_days === 0 && work_hours > 0;

                                return (
                                    <React.Fragment>
                                        {/* Working Hours */}
                                        {isHourType && (
                                            <div className="col-12">
                                                <NumberInput
                                                    key={'workingHours'}
                                                    inputId="workingHours"
                                                    label="Working hours"
                                                    labelHtmlFor="workingHours"
                                                    placeholder="Enter working hours"
                                                    onChange={(e: InputNumberChangeEvent) => setWorkingHours(e.value || null)}
                                                    suffix={` Hr${workingHours && workingHours > 1 ? 's' : ''}`}
                                                    minFractionDigits={1}
                                                    maxFractionDigits={2}
                                                    value={workingHours}
                                                    required={true}
                                                    min={0}
                                                    error={workingHoursError}
                                                    formGroupClassName="mb-3"
                                                />
                                            </div>
                                        )}

                                        {/* Working Day */}
                                        {isDayType && (
                                            <div className="col-12">
                                                <NumberInput
                                                    key={'workingDays'}
                                                    inputId="workingDays"
                                                    label="Working days"
                                                    labelHtmlFor="workingDays"
                                                    placeholder="Enter working days"
                                                    onChange={(e: InputNumberChangeEvent) => setWorkingDays(e.value || null)}
                                                    suffix={` Day${workingDays && workingDays > 1 ? 's' : ''}`}
                                                    minFractionDigits={1}
                                                    maxFractionDigits={2}
                                                    value={workingDays}
                                                    required={true}
                                                    min={0}
                                                    max={1}
                                                    error={workingDaysError}
                                                    formGroupClassName="mb-3"
                                                />
                                            </div>
                                        )}
                                    </React.Fragment>
                                );
                            })()}
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Staff payment modal */}
            <Dialog
                visible={showStaffPaymentModal}
                headerClassName="custom_modal_header"
                header={staffPaymentModalHeader}
                footer={staffPaymentModalFooter}
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseStaffPaymentModal}
            >
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-3 pt-sm-2 pb-sm-0 w-100">
                        <div className="row">
                            {paymentStaffError && (
                                <div className="col-12 mb-3">
                                    <Message
                                        severity="error"
                                        text={paymentStaffError}
                                        className="custom_form_msg"
                                    />
                                </div>
                            )}

                            {/* Payment date */}
                            <div className="col-12">
                                <DatePicker
                                    key={`staffPaymentDate`}
                                    id="staffPaymentDate"
                                    label="Date"
                                    labelHtmlFor="staffPaymentDate"
                                    required={true}
                                    value={staffPaymentDate}
                                    placeholder="dd/mm/yyyy"
                                    onChange={setStaffPaymentDate}
                                    error={staffPaymentDateError}
                                    showClear
                                    onClear={() => setStaffPaymentDate(null)}
                                />
                            </div>

                            {/* Expense */}
                            <div className="col-12">
                                <div className="page_form_group">
                                    <label htmlFor="paymentExpense" className="custom_form_label is_required">Payment for</label>
                                    <Dropdown
                                        key={`paymentExpense`}
                                        id="paymentExpense"
                                        value={paymentExpense}
                                        onChange={(e: DropdownChangeEvent) => setPaymentExpense(e.value)}
                                        optionLabel="expense_name"
                                        filter
                                        emptyFilterMessage="Expense you searched for wasn’t found."
                                        emptyMessage="No expense(s) found!"
                                        filterPlaceholder="Filter by expense name."
                                        options={expenses}
                                        panelClassName="status_option_panel"
                                        placeholder="Select expense"
                                        className="form_dropdown w-100 text-capitalize"
                                        loading={expenseLoading}
                                    />

                                    {paymentExpenseError &&
                                        <small className="form_error_msg">{paymentExpenseError}</small>
                                    }

                                    {expenseError &&
                                        <small className="form_error_msg">{expenseError}</small>
                                    }
                                </div>
                            </div>

                            {/* Amount */}
                            <div className="col-12">
                                <NumberInput
                                    inputId="staffPaymentAmount"
                                    label="Amount"
                                    labelHtmlFor="staffPaymentAmount"
                                    placeholder="Enter amount"
                                    onChange={(e: InputNumberChangeEvent) => setStaffPaymentAmount(e.value || null)}
                                    value={staffPaymentAmount}
                                    required={true}
                                    minFractionDigits={2}
                                    maxFractionDigits={2}
                                    prefix={currencySymbol + " "}
                                    min={0}
                                    error={staffPaymentAmountError}
                                    formGroupClassName="mb-2"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Attendance view modal */}
            <Dialog
                visible={showAttendanceViewModal}
                headerClassName="custom_modal_header"
                header={attendanceViewModalHeader}
                dismissableMask
                closeOnEscape={false}
                className="custom_modal_dialog modal_dialog_md"
                onHide={handleCloseAttendanceViewModal}
            >
                <div className="custom_modal_body">
                    <div className="p-1">
                        <div className="row">
                            <div className="col-12 mb-3">
                                <h4 className="view_data_head">
                                    <i className="bi bi-calendar-check me-2"></i>
                                    Attendance details
                                </h4>

                                <article className="data_view_area">
                                    <ViewDataGroup
                                        title="Project"
                                        value={selectedDayAttendanceData?.full_address}
                                    />

                                    <ViewDataGroup
                                        title="Date"
                                        value={selectedAttendanceData?.attendance_date}
                                    />

                                    {selectedAttendanceData && (() => {
                                        const { work_days = 0, work_hours = 0 } = selectedAttendanceData;

                                        const isDayType = work_hours === 0 && work_days > 0;
                                        const isHourType = work_days === 0 && work_hours > 0;

                                        const dayLabel = String(work_days).padStart(2, '0') + ' day' + (work_days > 1 ? 's' : '');
                                        const hourLabel = String(work_hours).padStart(2, '0') + ' hour' + (work_hours > 1 ? 's' : '');

                                        return (
                                            <React.Fragment>
                                                {isDayType && (
                                                    <ViewDataGroup
                                                        title="Working days"
                                                        value={dayLabel}
                                                    />
                                                )}

                                                {isHourType && (
                                                    <ViewDataGroup
                                                        title="Working hours"
                                                        value={hourLabel}
                                                    />
                                                )}
                                            </React.Fragment>
                                        );
                                    })()}

                                    <ViewDataGroup
                                        title="Wage on the day"
                                        isAmount
                                        value={selectedAttendanceData?.this_day_wage}
                                    />
                                </article>
                            </div>

                            {selectedAttendanceData?.payed_data && (
                                <div className="col-12 mb-3">
                                    <h4 className="view_data_head">
                                        <i className="bi bi-cash me-2"></i>
                                        Payment details
                                    </h4>

                                    <article className="data_view_area">
                                        <ViewDataGroup
                                            title="Paid amount"
                                            isAmount
                                            value={selectedAttendanceData?.payed_data?.payed_amount}
                                        />

                                        <ViewDataGroup
                                            title="Advance payment"
                                            isAmount
                                            value={selectedAttendanceData?.payed_data?.advance_payment}
                                        />

                                        <ViewDataGroup
                                            title="Total amount"
                                            isAmount
                                            value={selectedAttendanceData?.payed_data?.grand_total}
                                        />
                                    </article>
                                </div>
                            )}

                            <div className="col-12">
                                <h4 className="view_data_head">
                                    <i className="bi bi-person-vcard me-2"></i>
                                    Employee details
                                </h4>

                                <article className="data_view_area">
                                    <ViewDataGroup
                                        title="First name"
                                        value={selectedAttendanceData?.personalInfo?.first_name}
                                    />

                                    <ViewDataGroup
                                        title="Last name"
                                        value={selectedAttendanceData?.personalInfo?.last_name}
                                    />

                                    <ViewDataGroup
                                        title="Email"
                                        isValueTextCapitalized={false}
                                        value={selectedAttendanceData?.personalInfo?.email}
                                    />

                                    <ViewDataGroup
                                        title="Contact no."
                                        value={selectedAttendanceData?.personalInfo?.mobile}
                                    />

                                    <ViewDataGroup
                                        title="Lanline"
                                        value={selectedAttendanceData?.personalInfo?.landline}
                                    />

                                    <ViewDataGroup
                                        title="Address"
                                        value={selectedAttendanceData?.personalInfo?.address}
                                    />

                                    <ViewDataGroup
                                        title="City"
                                        value={selectedAttendanceData?.personalInfo?.city}
                                    />

                                    <ViewDataGroup
                                        title="Role"
                                        value={selectedAttendanceData?.userRoleInfo?.role_name}
                                    />
                                </article>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Staff view detail modal */}
            <Dialog
                visible={showStaffViewDetailModal}
                headerClassName="custom_modal_header"
                header={staffViewDetailModalHeader}
                dismissableMask
                closeOnEscape={false}
                className="custom_modal_dialog modal_dialog_sm custom"
                contentClassName="pt-0"
                onHide={handleCloseStaffViewDetailModal}
            >
                <div className="custom_modal_body">
                    <div className="p-1 pt-0">
                        <div className="add_data_switch_btn_area sticky">
                            <button className={`add_data_switch_btn p-ripple ${staffDetailViewState === 'Attendance' ? 'active' : ''}`}
                                type="button"
                                role="tab"
                                onClick={() => setStaffDetailViewState('Attendance')}
                            >
                                Attendance
                                <Ripple />
                            </button>

                            <button className={`add_data_switch_btn p-ripple ${staffDetailViewState === 'Payment' ? 'active' : ''}`}
                                type="button"
                                role="tab"
                                onClick={() => setStaffDetailViewState('Payment')}
                            >
                                Payment
                                <Ripple />
                            </button>
                        </div>

                        <article className="data_view_area mb-3">
                            <ViewDataGroup
                                title="Employee: "
                                value={`${staffFilter?.personalInfo?.first_name} ${staffFilter?.personalInfo?.last_name}`}
                                isValueHighlighted
                                titleWrapClassName='col-5 col-sm-4'
                                valueWrapClassName='col-7 col-sm-8'
                            />

                            <ViewDataGroup
                                title="Site: "
                                value={staffSiteFilter?.full_address}
                                titleWrapClassName='col-5 col-sm-4'
                                valueWrapClassName='col-7 col-sm-8'
                            />

                            <div className="view_data_group">
                                <div className="row">
                                    <div className="col-5 col-sm-4 d-flex align-items-center">
                                        <h5 className="view_data_title">Month :</h5>
                                    </div>
                                    <div className="col-7 col-sm-8">
                                        <h5 className="view_data_content">
                                            <DatePicker
                                                key={`staffViewDetailMonthFilter`}
                                                id="staffViewDetailMonthFilter"
                                                labelHtmlFor="staffViewDetailMonthFilter"
                                                value={staffViewDetailMonthFilter}
                                                maxDate={today}
                                                placeholder="MM yy"
                                                dateFormat='M yy'
                                                view="month"
                                                onChange={setstaffViewDetailMonthFilter}
                                                className="readonly_disabled"
                                                formGroupClassName='mb-0'
                                                showIcon
                                                icon="bi bi-calendar2-fill"
                                            />
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </article>

                        <div className="row">
                            {loadingViewDetail ? (
                                <div className="col-12">
                                    <div className="position-relative" style={{ minHeight: '250px' }}>
                                        <CustomTableLoader />
                                    </div>
                                </div>
                            ) : errorViewDetail ? (
                                <div className="col-12">
                                    <div className="no_records_found" style={{ minHeight: '250px' }}>
                                        <i className="bi bi-exclamation-circle me-1"></i>
                                        There was and error fetching staff {staffDetailViewState?.toLowerCase()} details
                                    </div>
                                </div>
                            ) : viewDetail ? (
                                <React.Fragment>
                                    {staffDetailViewState === 'Attendance' && (
                                        <div className="col-12">
                                            <div className="calendar_inline_view_container">
                                                <Calendar
                                                    key="staffAttendanceCalendar"
                                                    inputId="employeeAttendanceDate"
                                                    onChange={() => { }}
                                                    className="calendar_inline_view"
                                                    inline
                                                    viewDate={viewDate}
                                                    onViewDateChange={(e) => setViewDate(e.value)}
                                                    dateTemplate={dateTemplate}
                                                />
                                            </div>

                                            {viewDetail?.project_wise_data && viewDetail?.project_wise_data?.length > 0 ? (
                                                <div className="attendance_summary_table_area">
                                                    <div className="table-responsive">
                                                        <table className="table attendance_summary_table">
                                                            <thead>
                                                                <tr>
                                                                    <th className="address_column">Site</th>
                                                                    <th className="text-end">Count</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {viewDetail?.project_wise_data?.map((project) => {
                                                                    return (
                                                                        <tr key={project?.project_id}>
                                                                            <td className="text-capitalize">
                                                                                <span className="d-flex gap-2 justify-content-start align-items-center">
                                                                                    <span className="color_display_badge"
                                                                                        style={{
                                                                                            width: '28px',
                                                                                            height: '28px',
                                                                                            borderRadius: '50%',
                                                                                            flexShrink: 0,
                                                                                            position: 'relative',
                                                                                            backgroundColor: `${project?.colour_code ?? '#DDD'}`,
                                                                                            border: '1px solid #FFF'
                                                                                        }}
                                                                                    />
                                                                                    {project?.project_data?.full_address ?? '---'}
                                                                                </span>
                                                                            </td>

                                                                            <td className="text-end">
                                                                                {project?.count !== null ? String(project?.count).padStart(2, '0') : '---'}
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="no_records_found" style={{ marginTop: '15px', minHeight: '140px' }}>
                                                    <i className="bi bi-exclamation-circle me-1"></i>
                                                    No attendance data available.
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {staffDetailViewState === 'Payment' && (
                                        <div className="col-12">
                                            {/* Wages */}
                                            <div className="data_list_expand_area">
                                                <div className="data_list_expand_header no_expand">
                                                    <h6>Wages: <span>({viewDetail?.month ?? ''})</span></h6>
                                                    <h6 className="value">
                                                        {amountDisplay(viewDetail?.total_wage ?? 0)}
                                                    </h6>
                                                </div>
                                            </div>

                                            {/* Other expenses */}
                                            {viewDetail?.other_expense_list &&
                                                viewDetail.other_expense_list.some(
                                                    item => (item.list?.length ?? 0) > 0
                                                ) && (
                                                    <React.Fragment>
                                                        {viewDetail?.other_expense_list
                                                            ?.filter(exp => (exp.list?.length ?? 0) > 0)
                                                            .map(otherExpense => {
                                                                const isExpanded = expandedExpenseIds.includes(otherExpense.id);

                                                                return (
                                                                    <div className="data_list_expand_area" key={otherExpense?.id}>
                                                                        <div
                                                                            className={`data_list_expand_header p-ripple ${isExpanded ? "expanded" : ""}`}
                                                                            onClick={() => toggleExpandExpense(otherExpense?.id)}
                                                                        >
                                                                            <i className="bi bi-caret-right-fill"></i>
                                                                            <h6>{otherExpense?.expense_name}:</h6>
                                                                            <h6 className="value">
                                                                                {amountDisplay(otherExpense?.total_amount ?? 0)}
                                                                            </h6>
                                                                            <Ripple />
                                                                        </div>

                                                                        <AnimatePresence initial={false}>
                                                                            {isExpanded && (
                                                                                <motion.div
                                                                                    className="data_list_expand_body"
                                                                                    initial={{ height: 0, opacity: 0 }}
                                                                                    animate={{ height: "auto", opacity: 1 }}
                                                                                    exit={{ height: 0, opacity: 0 }}
                                                                                    transition={{ duration: 0.35, ease: "easeInOut" }}
                                                                                    style={{ overflow: "hidden" }}
                                                                                >
                                                                                    <div className="table-responsive">
                                                                                        <table className="table attendance_summary_table">
                                                                                            <thead>
                                                                                                <tr>
                                                                                                    <th className="address_column">Date</th>
                                                                                                    <th className="text-end">Amount</th>

                                                                                                    {(hasPermissionEditStaffPayment || hasPermissionDeleteStaffPayment) && (
                                                                                                        <th style={{ width: '60px' }}></th>
                                                                                                    )}
                                                                                                </tr>
                                                                                            </thead>

                                                                                            {otherExpense?.list && otherExpense?.list?.length > 0 ? (
                                                                                                <tbody>
                                                                                                    {otherExpense?.list?.map((expense) => {
                                                                                                        return (
                                                                                                            <tr key={expense?.id}>
                                                                                                                <td className="text-capitalize">
                                                                                                                    {expense?.date ?? '---'}
                                                                                                                </td>

                                                                                                                <td className="text-end">
                                                                                                                    {expense?.payed_amount !== null ? amountDisplay(expense?.payed_amount ?? 0) : '---'}
                                                                                                                </td>

                                                                                                                {(hasPermissionEditStaffPayment || hasPermissionDeleteStaffPayment) && (
                                                                                                                    <td className="text-center">
                                                                                                                        <div className="inline_action_area">
                                                                                                                            {hasPermissionEditStaffPayment && (
                                                                                                                                <button className="inline_action_btn is_btn"
                                                                                                                                    onClick={() => handleEditStaffPayment(expense)}
                                                                                                                                >
                                                                                                                                    <i className="bi bi-pencil-square"></i>
                                                                                                                                </button>
                                                                                                                            )}

                                                                                                                            {hasPermissionDeleteStaffPayment && (
                                                                                                                                <React.Fragment>
                                                                                                                                    {staffPaymentDeleteLoadingId === expense?.id ? (
                                                                                                                                        <div className="table_action_loader_area inline_action">
                                                                                                                                            <ProgressSpinner
                                                                                                                                                className="table_action_loader inline_action"
                                                                                                                                                style={{ width: '18px', height: '18px' }}
                                                                                                                                                strokeWidth="7"
                                                                                                                                                fill="transparent"
                                                                                                                                                animationDuration="1s"
                                                                                                                                            />
                                                                                                                                        </div>
                                                                                                                                    ) : (
                                                                                                                                        <button className="inline_action_btn danger is_btn"
                                                                                                                                            onClick={() => handleDeleteStaffPayment(expense)}
                                                                                                                                        >
                                                                                                                                            <i className="bi bi-trash3"></i>
                                                                                                                                        </button>
                                                                                                                                    )}
                                                                                                                                </React.Fragment>
                                                                                                                            )}
                                                                                                                        </div>
                                                                                                                    </td>
                                                                                                                )}
                                                                                                            </tr>
                                                                                                        )
                                                                                                    })}
                                                                                                </tbody>
                                                                                            ) : (
                                                                                                <tbody>
                                                                                                    <tr>
                                                                                                        <td colSpan={(hasPermissionEditStaffPayment || hasPermissionDeleteStaffPayment) ? 3 : 2} className="text_muted text-center">
                                                                                                            <i className="bi bi-exclamation-circle me-1"></i>
                                                                                                            No data for {otherExpense?.expense_name?.toLowerCase()} expenses was available.
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            )}
                                                                                        </table>
                                                                                    </div>
                                                                                </motion.div>
                                                                            )}
                                                                        </AnimatePresence>
                                                                    </div>
                                                                )
                                                            })}
                                                    </React.Fragment>
                                                )
                                            }

                                            {/* Paid data */}
                                            <div className="data_list_expand_area">
                                                <div
                                                    className={`data_list_expand_header p-ripple ${expandedPaidData ? 'expanded' : ''}`}
                                                    onClick={toggleExpandPaidData}
                                                >
                                                    <i className="bi bi-caret-right-fill"></i>
                                                    <h6>Paid: <span>(Wages)</span></h6>
                                                    <h6 className="value">
                                                        {amountDisplay(viewDetail?.total_paid ?? 0)}
                                                    </h6>
                                                    <Ripple />
                                                </div>

                                                <AnimatePresence initial={false}>
                                                    {expandedPaidData && (
                                                        <motion.div
                                                            className="data_list_expand_body"
                                                            initial={{ height: 0, opacity: 0 }}
                                                            animate={{ height: "auto", opacity: 1 }}
                                                            exit={{ height: 0, opacity: 0 }}
                                                            transition={{ duration: 0.35, ease: "easeInOut" }}
                                                            style={{ overflow: "hidden" }}
                                                        >
                                                            <div className="table-responsive">
                                                                <table className="table attendance_summary_table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="address_column">Date</th>
                                                                            <th className="text-end">Amount</th>

                                                                            {(hasPermissionEditStaffPayment || hasPermissionDeleteStaffPayment) && (
                                                                                <th style={{ width: '60px' }}></th>
                                                                            )}
                                                                        </tr>
                                                                    </thead>

                                                                    {viewDetail?.payed_data_list && viewDetail?.payed_data_list?.length > 0 ? (
                                                                        <tbody>
                                                                            {viewDetail?.payed_data_list?.map((paidData) => {
                                                                                return (
                                                                                    <tr key={paidData?.id}>
                                                                                        <td className="text-capitalize">
                                                                                            {paidData?.date ?? '---'}
                                                                                        </td>

                                                                                        <td className="text-end">
                                                                                            {paidData?.payed_amount !== null ? amountDisplay(paidData?.payed_amount ?? 0) : '---'}
                                                                                        </td>

                                                                                        {(hasPermissionEditStaffPayment || hasPermissionDeleteStaffPayment) && (
                                                                                            <td className="text-center">
                                                                                                <div className="inline_action_area">
                                                                                                    {hasPermissionEditStaffPayment && (
                                                                                                        <button
                                                                                                            className="inline_action_btn is_btn"
                                                                                                            onClick={() => handleEditStaffPayment(paidData)}
                                                                                                        >
                                                                                                            <i className="bi bi-pencil-square"></i>
                                                                                                        </button>
                                                                                                    )}

                                                                                                    {hasPermissionDeleteStaffPayment && (
                                                                                                        <React.Fragment>
                                                                                                            {staffPaymentDeleteLoadingId === paidData?.id ? (
                                                                                                                <div className="table_action_loader_area inline_action">
                                                                                                                    <ProgressSpinner
                                                                                                                        className="table_action_loader inline_action"
                                                                                                                        style={{ width: '18px', height: '18px' }}
                                                                                                                        strokeWidth="7"
                                                                                                                        fill="transparent"
                                                                                                                        animationDuration="1s"
                                                                                                                    />
                                                                                                                </div>
                                                                                                            ) : (
                                                                                                                <button className="inline_action_btn danger is_btn"
                                                                                                                    onClick={() => handleDeleteStaffPayment(paidData)}
                                                                                                                >
                                                                                                                    <i className="bi bi-trash3"></i>
                                                                                                                </button>
                                                                                                            )}
                                                                                                        </React.Fragment>
                                                                                                    )}
                                                                                                </div>
                                                                                            </td>
                                                                                        )}
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                        </tbody>
                                                                    ) : (
                                                                        <tbody>
                                                                            <tr>
                                                                                <td colSpan={(hasPermissionEditStaffPayment || hasPermissionDeleteStaffPayment) ? 3 : 2} className="text_muted text-center">
                                                                                    <i className="bi bi-exclamation-circle me-1"></i>
                                                                                    Paid history not available.
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    )}
                                                                </table>
                                                            </div>
                                                        </motion.div>
                                                    )}
                                                </AnimatePresence>
                                            </div>

                                            {/* Cumulative */}
                                            <div className="data_list_expand_area">
                                                <div className="data_list_expand_header no_expand">
                                                    <h6>Cumulative:</h6>
                                                    <h6 className="value">
                                                        {amountDisplay(viewDetail?.cumulative ?? 0)}
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </React.Fragment>
                            ) : (
                                <div className="col-12">
                                    <div className="no_records_found" style={{ minHeight: '250px' }}>
                                        <i className="bi bi-exclamation-circle me-1"></i>
                                        No {staffDetailViewState?.toLowerCase()} details found!
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Share modal */}
            <ShareModal
                isOpen={showContactShareModal}
                canEditOption={false}
                loading={loading}
                sharedList={sharedList}
                projectContactIds={projectContactIds}
                onClose={handleCloseShareModal}
                onShare={shareDataFunction}
                title="Share Attendance"
            />
            {/*  */}


            {/* Site employee modal */}
            <Dialog
                visible={showSiteEmployeeModal}
                headerClassName="custom_modal_header"
                header={siteEmployeeModalHeader}
                footer={siteEmployeeModalFooter}
                dismissableMask
                className="custom_modal_dialog modal_dialog_md"
                contentClassName="py-0"
                onHide={handleCloseSiteEmployeeModal}
            >
                <div className="custom_modal_body">
                    <div className="filter_header_area">
                        <div className="row">
                            <div className="col-12 px-0">
                                <div className="filter_input_area">
                                    <div className="filter_input_grp w-100 mb-0">
                                        <InputText
                                            key={`siteEmployeeSearchKey`}
                                            id="siteEmployeeSearchKey"
                                            value={siteEmployeeSearchKey}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                setSiteEmployeeSearchKey(e.target.value)
                                            }
                                            className="custom_form_input"
                                            placeholder="Search employee here"
                                            type={"search"}
                                        />
                                        {siteEmployeeSearchKey ? (
                                            <i
                                                className="bi bi-x-lg data_search_input_clear"
                                                onClick={() => setSiteEmployeeSearchKey("")}
                                            ></i>
                                        ) : (
                                            <i className="bi bi-search"></i>
                                        )}
                                    </div>

                                    <button
                                        className="add_data_link_btn p-ripple radiused"
                                        onClick={handleNavigateEmployeesWithState}
                                    >
                                        <i className="bi bi-plus-circle"></i>
                                        <span>More Employees</span>
                                        <i className="bi bi-box-arrow-up-right"></i>
                                        <Ripple />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {siteEmployeeLoading === true ? (
                        <div className="loading_container pos_rel">
                            <ProgressSpinner
                                className="progresscircle custom"
                                style={{ width: "50px", height: "50px", stroke: "#8953D7" }}
                                strokeWidth="8"
                                fill="var(--surface-ground)"
                                animationDuration="1s"
                            />
                        </div>
                    ) : (
                        <React.Fragment>
                            {allSiteEmployeesData && allSiteEmployeesData?.length > 0 ? (
                                <DataTable
                                    value={allSiteEmployeesData}
                                    paginator
                                    size="small"
                                    rows={10}
                                    emptyMessage="No data found!"
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    tableStyle={{ maxWidth: "100%" }}
                                    paginatorDropdownAppendTo={"self"}
                                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                    className="page_table auto_height p-0 p-sm-2"
                                    dataKey="attenanceEmployee.personal_info_id"
                                    scrollable={false}
                                    rowHover
                                >
                                    <Column
                                        header="Employee"
                                        headerClassName="text_purple"
                                        body={siteEmployeeNameBody}
                                        style={{ width: "50%" }}
                                        className="py-3"
                                    ></Column>

                                    <Column
                                        header="Designation"
                                        headerClassName="text_purple"
                                        body={(rowData: SiteEmployeeType) => (
                                            <span className="text-capitalize">
                                                {rowData?.userRoleInfo?.display_role_name
                                                    ? rowData?.userRoleInfo?.display_role_name
                                                    : "---"}
                                            </span>
                                        )}
                                        style={{ width: "30%" }}
                                    ></Column>

                                    <Column
                                        header="Status"
                                        headerClassName="text_purple"
                                        alignHeader={"center"}
                                        body={employeeStatusBody}
                                        style={{ width: "20%" }}
                                    ></Column>
                                </DataTable>
                            ) : (
                                <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-4 w-100">
                                    <NoDataCreated
                                        containerClassname="pos_rel"
                                        message={`No employee(s) found!`}
                                    />
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </div>
            </Dialog>
            {/*  */}
        </React.Fragment>
    )
}

export default Attendance;